// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:32:34.787Z
// Property: Zeal at Quail (ID: 6767906449167311)
// Collections: 16 amenities, 5 floorplans (live), 44 photos, 63 POIs, 1 reviews, 5 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449167311",
  "property_external_id": "2162172",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/zeal-at-quail-oklahoma-city-ok/zty0nrz/",
  "property_google_business_url": "https://www.google.com/maps/place/Zeal+at+Quail/data=!4m2!3m1!1s0x0:0x4c38ad6b48190831?sa=X&ved=2ahUKEwiL342Hyc6TAxVRmGoFHRjwJfgQ_BJ6BAgVEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "53528527631",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "zeal-at-quail",
  "property_name": "Zeal at Quail",
  "property_website_url": "zealatquailapartmentsokc.com",
  "property_domain": null,
  "property_address": "14712 Mezzaluna Blvd",
  "property_full_address": "14712 Mezzaluna Blvd, Oklahoma City, OK 73134",
  "property_address_1": "14712 Mezzaluna Blvd",
  "property_address_2": null,
  "property_address_city": "Oklahoma City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73134",
  "property_address_country": "US",
  "property_address_county": "Oklahoma County",
  "property_neighborhood_address": "Northwest Oklahoma City",
  "property_address_latitude": "35.6193429",
  "property_address_longitude": "-97.5598094",
  "property_email": "zealatquaillanding@caseusa.om",
  "property_phone": "(405) 993-4130",
  "property_call_tracking_phone": "405-993-4130",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Zeal at Quail in Oklahoma City, our thoughtfully designed one and two-bedroom apartments blend comfort with modern luxury. Enjoy exceptional amenities like a sparkling pool, fitness areas, and pet-friendly fenced yards, all under the watchful eye of our dedicated management team. Make your move—explore our vibrant community today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Zeal at Quail, your ideal sanctuary located in the heart of Oklahoma City, OK. Offering expertly designed one and two-bedroom floor plans, our apartment community blends comfort and style with extensive amenities to elevate your living experience. Picture yourself enjoying resort-style living with 24-hour access and an on-site property manager dedicated to ensuring your needs are met.\n\nAt Zeal at Quail, we prioritize your convenience. Take advantage of our package service, on-site maintenance, and energy-efficient, stainless steel appliances, as well as full-size washer/dryer connections. Our community boasts a gated entrance for added security, complemented by an array of amenities including a refreshing pool, a state-of-the-art clubhouse, and outdoor living areas perfect for relaxation or socializing.\n\nUnleash your competitive spirit on our basketball court, challenge friends to a game of cornhole, or practice your putting skills on our well-maintained greens. Families will love the playground, ensuring children have a safe space to play. Enjoy ample opportunities to foster connections in our gathering spaces or take a leisurely stroll through our beautifully landscaped grounds.\n\nWith features such as wood-style flooring, walk-in closets, and fenced yards, your new apartment at Zeal at Quail is not just a place to live; it's a lifestyle. Ready to find your new home? Browse our availability or schedule a tour today to experience all that Zeal at Quail has to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07de-3be4-769c-8a5e-910b99229af0.webp",
  "property_featured_image_media": {
    "alt_text": "City skyline at dusk with illuminated buildings and a vibrant sunset.",
    "public_id": "019d07de-3be4-769c-8a5e-910b99229af0",
    "storage_key": "property/6767906449167311/019d07de-3be4-769c-8a5e-910b99229af0.webp",
    "width": 2000,
    "height": 650
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "152",
  "property_year_built": "2026",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "94.07894736842105",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "300-500",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of two pets allowed. Breed restrictions apply. Pets subject to management approval.",
  "property_pet_policy_description": "Pets are welcome in all our luxury apartment homes. No weight limit. Maximum of two pets allowed. Breed restrictions apply. Pets subject to management approval. Pet rent: $30 per pet per month. $500 one-time fee per pet (non‑refundable).",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://zealatquailapartmentsokc.securecafe.com/onlineleasing/zeal-at-quail/floorplans.aspx",
  "property_resident_portal_url": "https://zealatquailapartmentsokc.securecafenet.com/residentservices/zeal-at-quail/userlogin",
  "property_apply_now_url": "https://zealatquailapartmentsokc.securecafe.com/onlineleasing/zeal-at-quail/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-aae3-745f-890a-9965240140e3.webp",
  "property_primary_logo_media": {
    "alt_text": "Zeal at Quail logo",
    "public_id": "019d07dc-aae3-745f-890a-9965240140e3",
    "storage_key": "property/6767906449167311/019d07dc-aae3-745f-890a-9965240140e3.webp",
    "width": 1000,
    "height": 1072
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07de-48d8-7528-87ab-d9cff712ef6f.webp",
  "property_mono_white_logo_media": {
    "alt_text": "blank white image",
    "public_id": "019d07de-48d8-7528-87ab-d9cff712ef6f",
    "storage_key": "property/6767906449167311/019d07de-48d8-7528-87ab-d9cff712ef6f.webp",
    "width": 597,
    "height": 640
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07de-50bb-7629-943a-9ca587019775.webp",
  "property_mono_black_logo_media": {
    "alt_text": "A black screen.",
    "public_id": "019d07de-50bb-7629-943a-9ca587019775",
    "storage_key": "property/6767906449167311/019d07de-50bb-7629-943a-9ca587019775.webp",
    "width": 597,
    "height": 640
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#dfd2c1",
  "property_secondary_color": "#6c6f4f",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#8fb0b1",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "716 - 1080",
  "property_sqft_min": "716",
  "property_sqft_max": "1080",
  "property_price_range": "1299 - 2100",
  "property_price_min": "1299",
  "property_price_max": "2100",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/CaseAndAssociates/posts/quiet-surroundings-and-modern-living-come-together-at-zeal-at-quail-landing-loca/1451536460311075/",
  "property_instagram_url": "https://www.instagram.com/popular/zeal-okc/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJA7IWHiMdsocRMQgZSGutOEw",
  "property_youtube_url": "https://www.youtube.com/watch?v=EXR67N0JIHM",
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_near=quail-landing-apartment-homes-by-highmark-residential-oklahoma-city",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Zeal at Quail",
  "property_home_romance_title": "Embrace a Life of Love in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Zeal at Quail in Oklahoma City, where luxury meets leisure. Choose from our thoughtfully designed one and two-bedroom floor plans, enjoy 24-hour access to a vibrant clubhouse, relax by the pool, or score baskets on our court—all within a gated paradise. Your ideal lifestyle awaits!",
  "property_home_floorplans_blurb": "At Zeal at Quail in vibrant Oklahoma City, choose from stylish one and two-bedroom apartment floor plans that cater to your lifestyle. Each home offers modern amenities and a welcoming atmosphere. Browse our available options today to find the ideal space that fits your vision of comfort and convenience.",
  "property_home_gallery_blurb": "At Zeal at Quail in Oklahoma City, find your perfect one or two-bedroom retreat. With 24-hour access, a serene pool, and vibrant outdoor living spaces, your new home is both welcoming and energizing. Picture yourself enjoying our clubhouse, playground, and even a basketball court—this is more than a community; it's a lifestyle!",
  "property_home_neighborhood_blurb": "At Zeal at Quail in vibrant Oklahoma City, your perfect home awaits amid a tapestry of life. Enjoy nearby outdoor adventures like Will Rogers Gardens and Martin Park Nature Center, or catch a game at Paycom Center. Dive into local culture and amenities that elevate your living experience!",
  "property_home_reviews_blurb": "At Zeal at Quail in Oklahoma City, residents rave about the vibrant community atmosphere, highlighting, \"It feels like home the moment you walk in!\" Experience a flourishing lifestyle surrounded by modern amenities and friendly neighbors. Curious about why so many love calling us home? See what our residents have to say!",
  "property_neighborhood_blurb": "At Zeal at Quail, your new home is not just about stylish one and two-bedroom floor plans—it's a gateway to excitement! Just moments away, discover the vibrant offerings of Quail Springs Mall, invigorating parks, and renowned cultural attractions. Immerse yourself in a community where convenience meets adventure!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Zeal at Quail in Oklahoma City, experience a vibrant community with exceptional amenities tailored to your lifestyle. Enjoy 24-hour access, a refreshing pool, and inviting outdoor spaces with putt-putt greens. Choose from spacious one- and two-bedroom floor plans designed for comfort and convenience, complete with modern finishes.",
  "property_applynow_blurb": "Welcome to Zeal at Quail, where modern living meets convenience in Oklahoma City! Choose from thoughtfully designed one and two-bedroom floor plans, complete with energy-efficient appliances, spacious walk-in closets, and relaxing outdoor areas. Experience unmatched amenities like a sparkling pool, clubhouse, and 24-hour service. Lease your new home online today!",
  "property_contactus_blurb": "Welcome to Zeal at Quail, your ideal Oklahoma City sanctuary! Choose from our thoughtfully designed one and two-bedroom floor plans tailored to fit your lifestyle. With modern amenities and a vibrant community atmosphere, your perfect home awaits. Have questions? Contact our leasing team today for more information!",
  "property_faqs_blurb": "At Zeal at Quail in Oklahoma City, our thoughtfully designed one and two-bedroom apartments cater to your unique lifestyle. Curious about amenities, leasing, or pet policies? Our FAQs page is the perfect resource to guide you. Dive in and find the answers that matter most to you and your future home!",
  "property_floorplans_blurb": "At Zeal at Quail in Oklahoma City, discover thoughtfully designed floor plans that fit your lifestyle. Whether you prefer the cozy charm of a one-bedroom or the spacious comfort of a two-bedroom, each layout is crafted for modern living. Browse our available apartment homes to find your ideal space today!",
  "property_gallery_blurb": "At Zeal at Quail in Oklahoma City, each moment feels like an escape. Imagine retreating to your stylish one or two-bedroom haven, complete with modern amenities like a refreshing pool, outdoor gathering spaces, and a fun-filled playground. Picture yourself living here—where convenience meets vibrant community life!",
  "property_interactivemap_blurb": "Welcome to Zeal at Quail in Oklahoma City, where modern living meets convenience. Choose from our stylish one- and two-bedroom floor plans, complete with energy-efficient appliances and wood-style flooring. Enjoy amenities like a sparkling pool, vibrant clubhouse, and family-friendly playground. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Zeal at Quail in Oklahoma City, your furry companions are cherished guests! With no weight limits and space for two pets, you can make your luxury apartment truly feel like home. Just check in with us about breed specifics — together, we can create a pet-friendly paradise!",
  "property_referafriend_blurb": "Elevate your living experience at Zeal at Quail in Oklahoma City, OK! With stylish one and two-bedroom floor plans, you'll find the perfect space to call home. Great friends make great neighbors—refer a friend to our vibrant community today and embrace a life filled with connection and excitement!",
  "property_residentaccess_blurb": "Welcome to Zeal at Quail in vibrant Oklahoma City, OK! Elevate your living experience with our spacious one and two-bedroom floor plans tailored to your lifestyle. Access your resident portal effortlessly for rent payments, maintenance requests, and beyond—everything you need is just a click away!",
  "property_reviews_blurb": "At Zeal at Quail in Oklahoma City, residents rave about their homes, noting, “The community vibe is unparalleled!” Dive into our reviews to discover why our apartment community uniquely blends comfort and convenience. Join the conversation and see what makes Zeal at Quail the perfect place to call home!",
  "property_created_at": "1773946382596",
  "property_scheduletour_blurb": "At Zeal at Quail in Oklahoma City, choose from spacious one and two-bedroom floor plans designed for modern living. Ready to experience the vibrant community? Schedule a tour today and see what our residents love about calling Zeal at Quail home! Your ideal lifestyle awaits.",
  "property_thankyou_blurb": "Thank you for reaching out to Zeal at Quail in vibrant Oklahoma City! With thoughtfully designed one- and two-bedroom floor plans, your ideal living space is just around the corner. Our team will connect with you soon to unveil the possibilities of your new home. Stay tuned!",
  "property_virtualtours_blurb": "At Zeal at Quail in Oklahoma City, OK, each thoughtfully designed one and two-bedroom apartment invites you to experience modern living. Dive into our virtual tour and visualize your new home filled with vibrant community life and stylish amenities. Your ideal space awaits—explore it today!",
  "property_copyright": "2026 All Rights Reserved. Zeal at Quail",
  "property_seo_title_home": "Zeal at Quail |  Apartments in Oklahoma City, OK",
  "property_seo_description_home": "Elevate your lifestyle at Zeal at Quail! Discover spacious one and two-bedroom apartments with amenities like a pool and clubhouse. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Oklahoma City, OK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Zeal at Quail in Oklahoma City! Choose from our stylish one- and two-bedroom floor plans tailored for modern living.",
  "property_seo_title_amenities": "Amenities | Oklahoma City, OK Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Zeal at Quail! Enjoy resort-style amenities, spacious floor plans, and a vibrant OKC community. Your ideal apartment lifestyle awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Oklahoma City, OK",
  "property_seo_description_gallery": "Experience luxury at Zeal at Quail in OKC! Discover stunning one- and two-bedroom homes with exceptional amenities. Your new lifestyle awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Zeal at Quail Apartments",
  "property_seo_description_virtualtours": "Step into Zeal at Quail in Oklahoma City! Enjoy a virtual tour of our chic one and two-bedroom apartments, showcasing stylish living at its finest.",
  "property_seo_title_interactivemap": "Interactive Map | Zeal at Quail Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Zeal at Quail in Oklahoma City! Use our interactive map to explore one and two-bedroom apartments with top-notch amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Oklahoma City, OK",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhoods surrounding Zeal at Quail in Oklahoma City. From local favorites to hidden gems, see what awaits just steps from home!",
  "property_seo_title_contact": "Contact Us | Zeal at Quail",
  "property_seo_description_contact": "Reach out to Zeal at Quail in Oklahoma City! Our leasing team is ready to assist with your one and two-bedroom inquiries. Your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Oklahoma City, OK",
  "property_seo_description_faqs": "Find answers to your questions about Zeal at Quail in Oklahoma City! Explore our amenities and floor plans to see why our community is perfect for you.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Oklahoma City, OK",
  "property_seo_description_reviews": "Experience life at Zeal at Quail in OKC! Read resident reviews and see why our vibrant community, featuring pools, parks, and more, feels like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Oklahoma City, OK",
  "property_seo_description_applynow": "Elevate your lifestyle at Zeal at Quail in OKC! Choose from stylish one or two-bedroom apartments with top-notch amenities. Secure your future home today!",
  "property_seo_title_residentaccess": "Resident Access | Zeal at Quail",
  "property_seo_description_residentaccess": "Unlock convenience at Zeal at Quail! Access your resident portal to pay rent, schedule maintenance, and manage your home with just a click.",
  "property_seo_title_referafriend": "Refer A Friend | Zeal at Quail",
  "property_seo_description_referafriend": "Share the joy of great living at Zeal at Quail! Refer a friend and build your community in Oklahoma City. Great friends make great neighbors—join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Zeal at Quail",
  "property_seo_description_scheduletour": "Experience modern living at Zeal at Quail in Oklahoma City. Schedule a tour today and find your perfect home in a vibrant community that’s waiting for you!",
  "property_seo_title_privacy": "Privacy Policy | Zeal at Quail",
  "property_seo_description_privacy": "Uncover how Zeal at Quail safeguards your personal information in Oklahoma City. Your privacy matters—read our policy for full transparency!",
  "property_seo_title_accessibility": "Website Accessibility | Zeal at Quail",
  "property_seo_description_accessibility": "Join us at Zeal at Quail in OKC, where inclusivity and accessibility create a welcoming community for everyone. Feel at home with us!",
  "property_seo_title_sitemap": "Sitemap | Zeal at Quail",
  "property_seo_description_sitemap": "Navigate your way through Zeal at Quail's exceptional amenities and vibrant community in Oklahoma City. Check out our sitemap for an effortless journey!",
  "property_seo_title_thankyou": "Thank You | Zeal at Quail",
  "property_seo_description_thankyou": "Thank you for reaching out to Zeal at Quail! Our team will connect soon to assist you in finding your perfect apartment in vibrant Oklahoma City.",
  "property_seo_title_pets": "Pet Policy | Apartments in Oklahoma City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787866218267",
  "amenities": [
    {
      "id": "ec_c69fb09631e0554091b96c17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "127727675",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18ffdfbf21cd4b69ae15b331",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "127397559",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72fa3409a9b65f19eda7e890",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "127397561",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_28b940a3643e5f72087efb2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "127397563",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_68287e0c2014f54146a6f3e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "127397565",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_360c40e2b990cc2b2a7d5cba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "127727674",
      "title": "On-Site Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5d78c2d6eb1f302581583007",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "127575826",
      "title": "Putting Green",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3519f3e7dd6b7800a10adbd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "127397568",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b37a15ef3d269f5319e321ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "127397570",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d7cbbde04534948a830e8e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "128021920",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa9f8364dc73168baa830bbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "127399027",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ca8ecf84277557dcc33ba607",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "127399028",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f75937cef82e147079cc28e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "127399029",
      "title": "Central Heat & Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_538b77588fa661cbe6bc0fbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "127399030",
      "title": "Washer/Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a47d3bab0b56de87a4a27e02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "127399031",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b8bd10536f48f9e2968f0b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "yardi",
      "external_id": "127399034",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_6b87028f-81d1-40ac-9d9e-e299d24c5d86",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-774f-73bd-85cf-9f3000407e1e.webp",
      "image_media": {
        "alt_text": "Living room with fireplace, TV, seating, and kitchen island.",
        "public_id": "019e2302-774f-73bd-85cf-9f3000407e1e",
        "storage_key": "property/6767906449167311/019e2302-774f-73bd-85cf-9f3000407e1e.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living area with a modern fireplace, comfortable seating, and an open-concept kitchen perfect for entertaining.",
      "link": "",
      "alt_text": "Living room with fireplace, TV, seating, and kitchen island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8733b48-2dcd-408f-9173-aa331d69b55f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-e8b3-71bd-ab00-5b2f39389d8c.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with fireplace, TV, island, and dining table.",
        "public_id": "019e2302-e8b3-71bd-ab00-5b2f39389d8c",
        "storage_key": "property/6767906449167311/019e2302-e8b3-71bd-ab00-5b2f39389d8c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a cozy fireplace and entertainment center, seamlessly flowing into a modern kitchen with a large island and bar seating.",
      "link": "",
      "alt_text": "Living room and kitchen area with fireplace, TV, island, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a9e355b-5463-4ad2-947d-6dc8cb76d36a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-4695-7197-baa3-966cf537f007.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and bar stools, featuring stainless steel appliances and open shelving.",
        "public_id": "019e2303-4695-7197-baa3-966cf537f007",
        "storage_key": "property/6767906449167311/019e2303-4695-7197-baa3-966cf537f007.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen, perfect for entertaining, with a large island, bar seating, and ample storage.",
      "link": "",
      "alt_text": "Modern kitchen with island and bar stools, featuring stainless steel appliances and open shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5c480385-ad64-4829-8d57-27e1d83adffd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-9461-71c2-80e1-94f91c2b4d62.webp",
      "image_media": {
        "alt_text": "Cozy bedroom featuring a king-size bed, bedside tables, and a full-length mirror.",
        "public_id": "019e2303-9461-71c2-80e1-94f91c2b4d62",
        "storage_key": "property/6767906449167311/019e2303-9461-71c2-80e1-94f91c2b4d62.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this spacious and inviting bedroom, complete with a comfortable king-size bed, elegant bedside tables, and a large mirror for added depth.",
      "link": "",
      "alt_text": "Cozy bedroom featuring a king-size bed, bedside tables, and a full-length mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_82eb2543-9958-455f-9a56-5f05689a195f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-4b83-7289-b639-83090e557a62.webp",
      "image_media": {
        "alt_text": "Empty white walk-in closet with shelves.",
        "public_id": "019e2302-4b83-7289-b639-83090e557a62",
        "storage_key": "property/6767906449167311/019e2302-4b83-7289-b639-83090e557a62.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample shelving for storage.",
      "link": "",
      "alt_text": "Empty white walk-in closet with shelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_888a3e63-bb68-49f9-ad53-7dcad444b017",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-5125-73f8-8dfd-2e8730f2b998.webp",
      "image_media": {
        "alt_text": "Modern bathroom with wood-grain vanity, white countertop, sink, toilet, and striped shower curtain.",
        "public_id": "019e2303-5125-73f8-8dfd-2e8730f2b998",
        "storage_key": "property/6767906449167311/019e2303-5125-73f8-8dfd-2e8730f2b998.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this stylish bathroom featuring a sleek vanity, pristine white countertop, and a calming striped shower curtain, all designed for comfort and modern living.",
      "link": "",
      "alt_text": "Modern bathroom with wood-grain vanity, white countertop, sink, toilet, and striped shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9ed1a5b1-2762-4606-8f99-e9fae8cbee40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-e97d-743c-9289-d86861cbce6a.webp",
      "image_media": {
        "alt_text": "Modern living room with a leather couch, accent chair, coffee table, and TV.",
        "public_id": "019e2302-e97d-743c-9289-d86861cbce6a",
        "storage_key": "property/6767906449167311/019e2302-e97d-743c-9289-d86861cbce6a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room featuring a sleek entertainment center, cozy seating, and contemporary decor. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Modern living room with a leather couch, accent chair, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b3fe105c-b461-4664-8300-651e521a0756",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-73a9-745f-98cc-e772487b5075.webp",
      "image_media": {
        "alt_text": "Living room with a brown sofa, armchair, coffee table, and TV.",
        "public_id": "019e2302-73a9-745f-98cc-e772487b5075",
        "storage_key": "property/6767906449167311/019e2302-73a9-745f-98cc-e772487b5075.webp",
        "width": 3072,
        "height": 2046
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable brown sofa, accent armchair, coffee table with decor, and a large television on a media console.",
      "link": "",
      "alt_text": "Living room with a brown sofa, armchair, coffee table, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d4a35c17-3695-4632-ac4a-c55ff56149ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-e319-7394-91ec-d412da3e4048.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and ample counter space.",
        "public_id": "019e2302-e319-7394-91ec-d412da3e4048",
        "storage_key": "property/6767906449167311/019e2302-e319-7394-91ec-d412da3e4048.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore the fully equipped kitchen, featuring sleek cabinetry, a deep sink, and a contemporary faucet, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and ample counter space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a4e6bb05-4176-4fc7-92fa-5a301c5fe433",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-aafa-711f-916e-24738de9cf43.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, island with bar stools, and ample cabinet space.",
        "public_id": "019e2302-aafa-711f-916e-24738de9cf43",
        "storage_key": "property/6767906449167311/019e2302-aafa-711f-916e-24738de9cf43.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Showcasing a contemporary apartment kitchen, complete with a full suite of stainless steel appliances, a sleek island featuring comfortable bar stools, and abundant storage.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, island with bar stools, and ample cabinet space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a0eadba-3486-447f-9fb4-55f3b1fa9034",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-4e3c-7058-a687-c320d5dfca75.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and ample cabinet space.",
        "public_id": "019e2303-4e3c-7058-a687-c320d5dfca75",
        "storage_key": "property/6767906449167311/019e2303-4e3c-7058-a687-c320d5dfca75.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, a large sink, and light wood cabinetry. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and ample cabinet space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c8c43328-5df7-421b-aa41-7703e784eeba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-8f4f-73c9-9fbf-beeab7423c39.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, ceiling fan, and large mirror.",
        "public_id": "019e2303-8f4f-73c9-9fbf-beeab7423c39",
        "storage_key": "property/6767906449167311/019e2303-8f4f-73c9-9fbf-beeab7423c39.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our beautifully appointed bedrooms. Featuring elegant furnishings and a serene atmosphere.",
      "link": "",
      "alt_text": "Modern bedroom with a queen-size bed, ceiling fan, and large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_54b883fd-5ef2-40bf-b398-e9ecb6be178f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-8926-71c8-94ac-4c63ed356efb.webp",
      "image_media": {
        "alt_text": "Modern bathroom with marble tile, vanity, and tub.",
        "public_id": "019e2302-8926-71c8-94ac-4c63ed356efb",
        "storage_key": "property/6767906449167311/019e2302-8926-71c8-94ac-4c63ed356efb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a clean and modern bathroom, featuring elegant marble tile, a spacious vanity with ample counter space, and a relaxing bathtub.",
      "link": "",
      "alt_text": "Modern bathroom with marble tile, vanity, and tub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_355ed921-43e9-4d3f-8477-6370cbd31294",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-d6c3-733b-aba1-08650eea87fa.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, a breakfast bar with bar stools, and a small dining table.",
        "public_id": "019e2302-d6c3-733b-aba1-08650eea87fa",
        "storage_key": "property/6767906449167311/019e2302-d6c3-733b-aba1-08650eea87fa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious kitchen, complete with modern stainless steel appliances, a convenient breakfast bar, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, a breakfast bar with bar stools, and a small dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_428d28fb-3d55-4f97-b8a0-1dd2cb9f2e3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-9b71-76c6-97cc-3f67ba0b6633.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, island with bar stools, and ample cabinet space.",
        "public_id": "019e2302-9b71-76c6-97cc-3f67ba0b6633",
        "storage_key": "property/6767906449167311/019e2302-9b71-76c6-97cc-3f67ba0b6633.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen featuring sleek stainless steel appliances, a convenient island with seating, and stylish cabinetry. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, island with bar stools, and ample cabinet space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1e73bda5-2d39-4edf-876b-82b215210d0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-bebc-74e7-b649-7f757514d906.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, and view into a bathroom.",
        "public_id": "019e2302-bebc-74e7-b649-7f757514d906",
        "storage_key": "property/6767906449167311/019e2302-bebc-74e7-b649-7f757514d906.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, modern ceiling fan, and elegant decor. Enjoy direct access to a clean, well-appointed bathroom.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, ceiling fan, and view into a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f1d7396d-7290-4883-bc3d-ddfe884d2c5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-a46b-70d9-a735-4c4a16486454.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and glass-enclosed shower with marble tile.",
        "public_id": "019e2302-a46b-70d9-a735-4c4a16486454",
        "storage_key": "property/6767906449167311/019e2302-a46b-70d9-a735-4c4a16486454.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a floating vanity with a modern sink, a sleek glass-enclosed shower with marble-look tile, and decorative wall art.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and glass-enclosed shower with marble tile.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9c353b1e-e37d-434a-8949-28445793ee38",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-4eab-7618-b172-5a260f7f0720.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, ceiling fan, and decorative wall baskets.",
        "public_id": "019e2303-4eab-7618-b172-5a260f7f0720",
        "storage_key": "property/6767906449167311/019e2303-4eab-7618-b172-5a260f7f0720.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a queen-size bed with soft bedding, a ceiling fan for comfort, and a decorative arrangement of woven baskets on the wall.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, ceiling fan, and decorative wall baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a6efba8a-29e6-4b18-94b0-751714597b78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-bc7e-73cc-87a9-4a28d132d904.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a walk-in shower, vanity with a sink, and toilet.",
        "public_id": "019e2302-bc7e-73cc-87a9-4a28d132d904",
        "storage_key": "property/6767906449167311/019e2302-bc7e-73cc-87a9-4a28d132d904.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This updated bathroom features a spacious walk-in shower with marble-look tile, a modern vanity with ample counter space, and a toilet.",
      "link": "",
      "alt_text": "Modern bathroom with a walk-in shower, vanity with a sink, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_775f66b4-c7a5-4622-833b-cecaf24ff735",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-b798-7156-a4df-e9b5683c0c66.webp",
      "image_media": {
        "alt_text": "Modern open-concept living room and kitchen with stainless steel appliances, granite countertops, and island seating.",
        "public_id": "019e2302-b798-7156-a4df-e9b5683c0c66",
        "storage_key": "property/6767906449167311/019e2302-b798-7156-a4df-e9b5683c0c66.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with stainless steel appliances and bar seating, perfect for entertaining.",
      "link": "",
      "alt_text": "Modern open-concept living room and kitchen with stainless steel appliances, granite countertops, and island seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_02282a6a-99fc-4a6d-9232-644b0395119f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-babd-72a9-ac76-73fe282766e5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, light wood cabinets, white countertops, and decorative wall art.",
        "public_id": "019e2302-babd-72a9-ac76-73fe282766e5",
        "storage_key": "property/6767906449167311/019e2302-babd-72a9-ac76-73fe282766e5.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Discover this beautifully appointed kitchen featuring sleek stainless steel appliances, ample cabinet space, and elegant quartz countertops, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, light wood cabinets, white countertops, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_914bb876-14eb-4ac9-9e13-2298ed477261",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-a2c6-7581-a916-e6eccb57ceb0.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and a large island.",
        "public_id": "019e2302-a2c6-7581-a916-e6eccb57ceb0",
        "storage_key": "property/6767906449167311/019e2302-a2c6-7581-a916-e6eccb57ceb0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample cabinet space, and a sleek island perfect for meal prep and casual dining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_924badb9-69a5-4cd4-8915-9711ebfa87bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-9912-7348-8022-5f28a0842140.webp",
      "image_media": {
        "alt_text": "Kitchenette with a dining table and two chairs, next to a stainless steel refrigerator.",
        "public_id": "019e2302-9912-7348-8022-5f28a0842140",
        "storage_key": "property/6767906449167311/019e2302-9912-7348-8022-5f28a0842140.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Charming kitchenette featuring a compact dining set for two, accented by a modern stainless steel refrigerator and elegant cabinetry.",
      "link": "",
      "alt_text": "Kitchenette with a dining table and two chairs, next to a stainless steel refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3de1adcf-d188-4dba-a07d-e2b9ab7711a7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-6d35-7269-a5e3-8e3e40c4286a.webp",
      "image_media": {
        "alt_text": "A cozy bedroom with a king-sized bed, nightstand, lamp, ceiling fan, and a large window.",
        "public_id": "019e2303-6d35-7269-a5e3-8e3e40c4286a",
        "storage_key": "property/6767906449167311/019e2303-6d35-7269-a5e3-8e3e40c4286a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this inviting bedroom, featuring a comfortable king-sized bed, elegant decor, and ample natural light from the large window. Perfect for a peaceful retreat.",
      "link": "",
      "alt_text": "A cozy bedroom with a king-sized bed, nightstand, lamp, ceiling fan, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_976bfa87-e26c-4f93-8753-788ee3470d42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-da4a-7653-926b-06beb6c213a6.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, ceiling fan, and nightstand.",
        "public_id": "019e2302-da4a-7653-926b-06beb6c213a6",
        "storage_key": "property/6767906449167311/019e2302-da4a-7653-926b-06beb6c213a6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, a stylish ceiling fan, and a convenient nightstand with a lamp. Perfect for a relaxing retreat.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, ceiling fan, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9fd7d2ee-42fb-4864-94e0-101480c6a7d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-c9f5-7698-95c4-7e0f89e9cc8d.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and walk-in shower.",
        "public_id": "019e2302-c9f5-7698-95c4-7e0f89e9cc8d",
        "storage_key": "property/6767906449167311/019e2302-c9f5-7698-95c4-7e0f89e9cc8d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a white vanity with a sleek faucet, a clean toilet, and a spacious walk-in shower with marble-look tiles.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and walk-in shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e4dcb529-8c6d-4a71-a873-bc211482f1a9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-5b87-70cd-9a2e-48eb56798a2d.webp",
      "image_media": {
        "alt_text": "Empty laundry closet with hookups for washer and dryer, a shelf, and an electrical panel.",
        "public_id": "019e2302-5b87-70cd-9a2e-48eb56798a2d",
        "storage_key": "property/6767906449167311/019e2302-5b87-70cd-9a2e-48eb56798a2d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This laundry closet is ready for your washer and dryer. It includes hookups, ample shelving, and an electrical panel for your convenience.",
      "link": "",
      "alt_text": "Empty laundry closet with hookups for washer and dryer, a shelf, and an electrical panel.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8c2d164d-e391-4e5a-a190-723d6aed39bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-c461-7733-b4c5-59af62f01c95.webp",
      "image_media": {
        "alt_text": "Private fenced backyard with artificial grass and an air conditioning unit.",
        "public_id": "019e2303-c461-7733-b4c5-59af62f01c95",
        "storage_key": "property/6767906449167311/019e2303-c461-7733-b4c5-59af62f01c95.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your own private outdoor space with this fenced backyard, featuring artificial turf and a convenient air conditioning unit.",
      "link": "",
      "alt_text": "Private fenced backyard with artificial grass and an air conditioning unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eac07ffd-033b-439e-b36d-4fdaafee90c6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-e746-76fa-b655-01612f2b5083.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a clubhouse in the background.",
        "public_id": "019e2303-e746-76fa-b655-01612f2b5083",
        "storage_key": "property/6767906449167311/019e2303-e746-76fa-b655-01612f2b5083.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and a stylish clubhouse perfect for relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a clubhouse in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b358b206-1579-4ffd-a75e-4a66d80d85a6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-dbd1-7598-bb9b-cca5e1ff6d69.webp",
      "image_media": {
        "alt_text": "An outdoor swimming pool with lounge chairs and a backdrop of apartment buildings under a blue sky.",
        "public_id": "019e2303-dbd1-7598-bb9b-cca5e1ff6d69",
        "storage_key": "property/6767906449167311/019e2303-dbd1-7598-bb9b-cca5e1ff6d69.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our pristine outdoor swimming pool, surrounded by comfortable lounge chairs and scenic views of the community.",
      "link": "",
      "alt_text": "An outdoor swimming pool with lounge chairs and a backdrop of apartment buildings under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c68ae173-3a0f-4c99-b891-e921ad5c18c2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-e009-738c-97a7-cc4c716d20e0.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables in a residential community.",
        "public_id": "019e2303-e009-738c-97a7-cc4c716d20e0",
        "storage_key": "property/6767906449167311/019e2303-e009-738c-97a7-cc4c716d20e0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by comfortable lounge chairs and tables. Perfect for relaxing or socializing with neighbors.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables in a residential community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_871061fa-7edd-46a1-8848-35fcc9a45d96",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-db87-7174-845a-305160dc3368.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019e2303-db87-7174-845a-305160dc3368",
        "storage_key": "property/6767906449167311/019e2303-db87-7174-845a-305160dc3368.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_459a5249-7c37-4216-a9b4-a4cc61c35369",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-d50d-73ab-b734-3d56e779c524.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, stationary bikes, and weight machines.",
        "public_id": "019e2303-d50d-73ab-b734-3d56e779c524",
        "storage_key": "property/6767906449167311/019e2303-d50d-73ab-b734-3d56e779c524.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with a variety of cardio machines and strength training equipment.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, stationary bikes, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2bf8f604-f354-4f3e-845c-e5d50f68c796",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-bda3-77cd-81fb-836decbd25bf.webp",
      "image_media": {
        "alt_text": "Putting green with flags",
        "public_id": "019e2303-bda3-77cd-81fb-836decbd25bf",
        "storage_key": "property/6767906449167311/019e2303-bda3-77cd-81fb-836decbd25bf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Practice your golf swing on our on-site putting green, a perfect amenity for sports enthusiasts.",
      "link": "",
      "alt_text": "Putting green with flags",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c98c4ff7-a4ba-4caa-9885-3fe8b0c68bdb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-b97d-754f-9986-9a325a455921.webp",
      "image_media": {
        "alt_text": "Putting green and swimming pool area with lounge chairs at apartment complex.",
        "public_id": "019e2303-b97d-754f-9986-9a325a455921",
        "storage_key": "property/6767906449167311/019e2303-b97d-754f-9986-9a325a455921.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with a putting green and swimming pool, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Putting green and swimming pool area with lounge chairs at apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d3800815-69a5-417f-a684-b82824800c7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-b3b1-7719-a09a-ca8245241890.webp",
      "image_media": {
        "alt_text": "Outdoor lawn games area with cornhole boards and string lights.",
        "public_id": "019e2303-b3b1-7719-a09a-ca8245241890",
        "storage_key": "property/6767906449167311/019e2303-b3b1-7719-a09a-ca8245241890.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy fun and games in our community's outdoor lawn game area, complete with cornhole boards and festive string lights for evening enjoyment.",
      "link": "",
      "alt_text": "Outdoor lawn games area with cornhole boards and string lights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d1a0867a-df5d-4c24-86fe-31dbc953a8c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-95a7-73cf-b14d-01d55429a860.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with Adirondack chairs and fire pits.",
        "public_id": "019e2303-95a7-73cf-b14d-01d55429a860",
        "storage_key": "property/6767906449167311/019e2303-95a7-73cf-b14d-01d55429a860.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting outdoor lounge, featuring comfortable seating and fire pits, perfect for enjoying cool evenings.",
      "link": "",
      "alt_text": "Outdoor lounge area with Adirondack chairs and fire pits.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5b356dd0-b826-4571-951d-16086da49bd2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-96c3-753d-b416-e0b2bc2add88.webp",
      "image_media": {
        "alt_text": "Modern apartment fitness center with cardio machines, free weights, and a cable machine.",
        "public_id": "019e2303-96c3-753d-b416-e0b2bc2add88",
        "storage_key": "property/6767906449167311/019e2303-96c3-753d-b416-e0b2bc2add88.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio equipment and a wide selection of free weights and machines.",
      "link": "",
      "alt_text": "Modern apartment fitness center with cardio machines, free weights, and a cable machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_52a5754a-93b6-4739-87da-ff113a3871ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2303-9c25-70d4-b746-c4fbbab72343.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, free weights, and a weight machine.",
        "public_id": "019e2303-9c25-70d4-b746-c4fbbab72343",
        "storage_key": "property/6767906449167311/019e2303-9c25-70d4-b746-c4fbbab72343.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with treadmills, ellipticals, recumbent bikes, a full weight rack, and a multi-station weight machine. Perfect for your daily workout routine.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, free weights, and a weight machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_31a17851-2ee5-411c-ab25-bd9b21232438",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-754b-7670-a7ec-8bcda0094091.webp",
      "image_media": {
        "alt_text": "Business center with a computer, printer, and chairs.",
        "public_id": "019e2302-754b-7670-a7ec-8bcda0094091",
        "storage_key": "property/6767906449167311/019e2302-754b-7670-a7ec-8bcda0094091.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Work or print documents in our convenient business center, equipped with computers and a printer.",
      "link": "",
      "alt_text": "Business center with a computer, printer, and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_707f25bb-0133-4523-be6a-8172559fed14",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e2302-77c8-73dd-ad0d-ea93dcdcc8e1.webp",
      "image_media": {
        "alt_text": "Outdoor patio seating area with sofas, armchairs, and a fire pit, overlooking a pool and apartment buildings.",
        "public_id": "019e2302-77c8-73dd-ad0d-ea93dcdcc8e1",
        "storage_key": "property/6767906449167311/019e2302-77c8-73dd-ad0d-ea93dcdcc8e1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our spacious outdoor seating area, featuring comfortable sofas, armchairs, and a central fire pit. Enjoy the view of the sparkling pool and surrounding apartment community.",
      "link": "",
      "alt_text": "Outdoor patio seating area with sofas, armchairs, and a fire pit, overlooking a pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_64afab6b-cd02-4a9c-b3e1-034624faf65d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e1096-28b8-77de-b8bb-85a307708b0e.webp",
      "image_media": {
        "alt_text": "Aerial view of a residential community with a swimming pool, putting green, and townhomes.",
        "public_id": "019e1096-28b8-77de-b8bb-85a307708b0e",
        "storage_key": "property/6767906449167311/019e1096-28b8-77de-b8bb-85a307708b0e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Discover this vibrant community featuring a sparkling swimming pool, a fun putting green, and beautifully designed townhomes, perfect for modern living.",
      "link": "",
      "alt_text": "Aerial view of a residential community with a swimming pool, putting green, and townhomes.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7e4bb462-5ba8-40f0-97a1-a7cbfd578104",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e1096-1d0c-731c-a21c-ad9a5ca05814.webp",
      "image_media": {
        "alt_text": "Zeal at Quail community signage on a brick wall with landscaping.",
        "public_id": "019e1096-1d0c-731c-a21c-ad9a5ca05814",
        "storage_key": "property/6767906449167311/019e1096-1d0c-731c-a21c-ad9a5ca05814.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to Zeal at Quail, where community and comfort meet. Discover our beautifully designed spaces and vibrant atmosphere.",
      "link": "",
      "alt_text": "Zeal at Quail community signage on a brick wall with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_622faeed-eb20-4486-9701-2b2497faea92",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e1096-15a2-7098-a865-1d983546fbd9.webp",
      "image_media": {
        "alt_text": "Exterior view of a row of single-family rental homes with garages and driveways.",
        "public_id": "019e1096-15a2-7098-a865-1d983546fbd9",
        "storage_key": "property/6767906449167311/019e1096-15a2-7098-a865-1d983546fbd9.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Charming row of single-family homes featuring attached garages and private driveways, offering a comfortable and convenient living experience.",
      "link": "",
      "alt_text": "Exterior view of a row of single-family rental homes with garages and driveways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_3dc37aec-d436-4940-a384-5631f257948a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Topgolf Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "13313 Pawnee Dr, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers a fun atmosphere with games, kid clubs, and toddler clubs. They also highlight the affordable pricing, especially for groups, and the friendly and helpful staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-0426-7215-a5a5-a28166b8864c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-0426-7215-a5a5-a28166b8864c",
        "storage_key": "property/6767906449167311/019d07dd-0426-7215-a5a5-a28166b8864c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17880991546737991946&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-oklahoma-city",
      "poi_latitude": "35.6027127",
      "poi_longitude": "-97.5351879",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-607-7154",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d9051e79f5e9",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc0r8qRocsocRCqEU_xILJvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_65311161-5089-429b-a1b9-35eb60886839",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "8400 N Oklahoma Ave, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Bar with games such as pickleball and bocce and an on-site restaurant menu that encompasses wings to chicken sandwiches.",
      "poi_long_description": "People say this restaurant offers a variety of food, including chicken, ribs, and salads, and has many pickleball courts and other games. They also highlight the fun and chill atmosphere, and the friendly and helpful staff.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-4ff3-707c-8cf8-fcd55918d171.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-4ff3-707c-8cf8-fcd55918d171",
        "storage_key": "property/6767906449167311/019d07dd-4ff3-707c-8cf8-fcd55918d171.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://chickennpickle.com/location/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4621211403201137082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicken-n-pickle---oklahoma-city",
      "poi_latitude": "35.5567671",
      "poi_longitude": "-97.5089424",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-839-7011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d9051e79f5e9",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDbbROHYZsocRusnJd0nXIUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4b937c95-8606-42c0-8728-cc46d0f89c53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Main Event Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "1441 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Family-friendly venue offering bowling, laser tag and arcade games, along with pizza and burgers, plus a ropes course.",
      "poi_long_description": "People say this restaurant offers a variety of entertainment options, including bowling, arcade games, laser tag, and escape rooms, as well as pizza, wings, and drinks. They also highlight the fun atmosphere, suitable for families and birthday parties, and the friendly and helpful staff.\n\nSome reviews mention the games can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-028d-7664-a3dc-7a1df604add0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-028d-7664-a3dc-7a1df604add0",
        "storage_key": "property/6767906449167311/019d07dd-028d-7664-a3dc-7a1df604add0.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "http://www.mainevent.com/locations/oklahoma/oklahoma-city",
      "poi_directions_map_url": "https://maps.google.com/?cid=10621058190493493742&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "main-event-oklahoma-city",
      "poi_latitude": "35.6102071",
      "poi_longitude": "-97.5381584",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-751-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d9051e79f5e9",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bkHxccsocR7ikexyaUZZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_dcc7b854-4834-4306-b619-d15308f26c97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2100 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "People say this steakhouse serves great steaks, burgers, salads, and rolls with cinnamon butter. They also highlight the friendly staff, good service, and reasonable prices.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-500d-71dc-a095-ce72c3e67d32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-500d-71dc-a095-ce72c3e67d32",
        "storage_key": "property/6767906449167311/019d07dd-500d-71dc-a095-ce72c3e67d32.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/oklahoma-city-north-memorial-rd?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=3657567219942529703&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "35.6078943",
      "poi_longitude": "-97.5503319",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-755-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d9051e79f5e9",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiYzghGscsocRp5rJBgJKwjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_976d70ae-2725-4635-94b5-8906c1f4aee1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Clark Crew BBQ",
      "poi_type": "Restaurants",
      "poi_address": "3510 Northwest Expy, Oklahoma City, OK 73112, USA",
      "poi_short_description": "Laid-back restaurant firing pizzas in brick ovens & preparing generous burgers & sandwiches.",
      "poi_long_description": "Diners say this barbecue restaurant serves up delicious burnt ends, brisket, ribs, and cornbread. They also highlight the friendly and attentive service, and the lively back patio with live music.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-5129-756a-b57a-eab886e18883.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-5129-756a-b57a-eab886e18883",
        "storage_key": "property/6767906449167311/019d07dd-5129-756a-b57a-eab886e18883.webp",
        "width": 599,
        "height": 596
      },
      "poi_business_url": "http://www.clarkcrewbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3587788996052338906&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "clark-crew-bbq",
      "poi_latitude": "35.5323986",
      "poi_longitude": "-97.5816496",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-724-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d9051e79f5e9",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6r6_-4asocR2kjBPhVjyjE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_6a5a0768-0d43-447e-9128-555eecb66ddb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Quail Springs Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Sprawling shopping center containing retailers, restaurant options & a 24-screen movie theater.",
      "poi_long_description": "People say this shopping center offers a variety of stores, including clothing, shoes, and toys, as well as entertainment options like an arcade, movie theater, and aquarium. They also highlight the clean and safe environment, and the fun atmosphere for families.\n\nOther reviews mention the food court can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-e8ba-748e-8d65-1117b47692e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dc-e8ba-748e-8d65-1117b47692e8",
        "storage_key": "property/6767906449167311/019d07dc-e8ba-748e-8d65-1117b47692e8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.quailspringsmall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=254102542958583292&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "quail-springs-mall",
      "poi_latitude": "35.6130282",
      "poi_longitude": "-97.5584437",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-254-4979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-dfc4a385d678.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-dfc4a385d678",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-dfc4a385d678.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS_2JfGccsocR_N2RoerAhgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_33d2cdab-c4ac-4103-8fb4-d95d63d021d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "6409 Avondale Dr, Nichols Hills, OK 73116, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Shoppers say this grocery store offers a unique shopping experience with fresh produce, a wide selection of wines, and an array of flowers. They also highlight the friendly and helpful staff, reasonable prices, and clean store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-52e0-766e-b8d4-8761d10de41f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-52e0-766e-b8d4-8761d10de41f",
        "storage_key": "property/6767906449167311/019d07dd-52e0-766e-b8d4-8761d10de41f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/ok/nichols-hills/461/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6877173602117636080&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "35.5376946",
      "poi_longitude": "-97.5310595",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-843-5655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d37d944c30d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d37d944c30d0",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d37d944c30d0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIaTG8SUasocR8E_qTPSgcF8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_a40fb0f0-8348-4043-99bb-7b3d109852e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6001 N Western Ave, Oklahoma City, OK 73118, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh, organic produce, meats, and seafood, as well as unique and hard-to-find items. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-5517-7369-94d0-79113f9d1151.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-5517-7369-94d0-79113f9d1151",
        "storage_key": "property/6767906449167311/019d07dd-5517-7369-94d0-79113f9d1151.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/oklahomacity?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=551365353270644661&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "35.5340444",
      "poi_longitude": "-97.5305342",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-879-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d37d944c30d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d37d944c30d0",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d37d944c30d0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkeF-rCYasocRtY8nF97Xpgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_350cec2b-5174-47f5-8f8f-32d8756a587b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Crest Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "2200 W 15th St #124, Edmond, OK 73013, USA",
      "poi_short_description": "Supermarket featuring aisles of fresh groceries, baked goods and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-5521-76ef-80c2-dc09dfb38ee4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-5521-76ef-80c2-dc09dfb38ee4",
        "storage_key": "property/6767906449167311/019d07dd-5521-76ef-80c2-dc09dfb38ee4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.crestfoodsok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9428274884093566538&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crest-foods",
      "poi_latitude": "35.6368691",
      "poi_longitude": "-97.5127608",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-330-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d37d944c30d0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d37d944c30d0",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d37d944c30d0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVSeJIYgesocRSl4izw3214I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_cd7231a1-fe60-47a8-bc5c-3438186d0ea5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "1901 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has helpful and knowledgeable staff who are willing to assist with any task. They also highlight the friendly and efficient customer service, and the clean and well-stocked store.\n\nSome reviews mention the staff can be difficult to locate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-55a3-70d6-8aaf-e7ac5e206164.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-55a3-70d6-8aaf-e7ac5e206164",
        "storage_key": "property/6767906449167311/019d07dd-55a3-70d6-8aaf-e7ac5e206164.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.homedepot.com/l/Edmond/OK/Edmond/73013/3907?emt=MSEN?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5451913410994265011&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "35.6348467",
      "poi_longitude": "-97.4853011",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 10 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-330-0151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-dfc4a385d678.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-dfc4a385d678",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-dfc4a385d678.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9xQ7Wf4esocRs1uAoFwWqUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_4f33fe85-6040-4d6e-8a52-3cf7837959db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "University of Central Oklahoma",
      "poi_type": "Education",
      "poi_address": "100 N University Dr, Edmond, OK 73034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-fdb9-77a1-b7ef-7c7d1b5add0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dc-fdb9-77a1-b7ef-7c7d1b5add0e",
        "storage_key": "property/6767906449167311/019d07dc-fdb9-77a1-b7ef-7c7d1b5add0e.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.uco.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17296425383341636856&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "university-of-central-oklahoma",
      "poi_latitude": "35.657506",
      "poi_longitude": "-97.4709491",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 405-974-2727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d4a8d42da38a",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvZ0xm_BNr4cR-Lwg6j4_CfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_27b9ac99-709d-48db-a821-500c9ebbae1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Oklahoma Christian University",
      "poi_type": "Education",
      "poi_address": "2501 E Memorial Rd, Edmond, OK 73013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-fe38-75d8-ae86-8d0735d8636a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dc-fe38-75d8-ae86-8d0735d8636a",
        "storage_key": "property/6767906449167311/019d07dc-fe38-75d8-ae86-8d0735d8636a.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://www.oc.edu/?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6907680163806340117&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-christian-university",
      "poi_latitude": "35.6126232",
      "poi_longitude": "-97.4697937",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 405-425-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d4a8d42da38a",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN68XpyQfsocRFWSwsYIC3V8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_35d586b4-da02-4aa7-ab4e-5eafae480b71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Edmond Library - Metropolitan Library System",
      "poi_type": "Education",
      "poi_address": "10 S Blvd, Edmond, OK 73034, USA",
      "poi_short_description": "Popular, kid-friendly facility offering books for all ages, magazines, music, movies, programs, computers and toy areas.",
      "poi_long_description": "People say this public library offers a wide selection of books, including e-books and audiobooks available through the Libby app. They highlight the cozy and inviting atmosphere, and the helpful and friendly staff. They also like the convenient book reservation system and quick pick-up service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-5a0a-7652-a0e4-2f7c61888b15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-5a0a-7652-a0e4-2f7c61888b15",
        "storage_key": "property/6767906449167311/019d07dd-5a0a-7652-a0e4-2f7c61888b15.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrolibrary.org/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=5308985467338173646&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edmond-library---metropolitan-library-system",
      "poi_latitude": "35.6542015",
      "poi_longitude": "-97.4778675",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-341-9282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d4a8d42da38a",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ73psmrMfsocRzixngidOrUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_06851132-f3f2-4655-be3d-aed9547fbfd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Blue Zoo Aquarium Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "2501 W Memorial Rd Suite 125A, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Mall-based attraction featuring sharks, stingrays, snakes and other marine life plus a playground for kids.",
      "poi_long_description": "People say this aquarium offers a variety of aquatic, aviary, and reptilian exhibits, including stingray feeding, a bird room with parakeets, and a mermaid show. They also highlight the interactive experiences, such as water tables, a pirate ship play area, and a rock climbing wall, as well as the friendly and helpful staff.\n\nOther reviews mention the exhibits can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-5a38-74f6-b9f5-0a9aaf11ec37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-5a38-74f6-b9f5-0a9aaf11ec37",
        "storage_key": "property/6767906449167311/019d07dd-5a38-74f6-b9f5-0a9aaf11ec37.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://oklahomacity.bluezoo.us/?utm_source=google&utm_medium=organic&utm_campaign=Google+Business+Profile+-+OKC",
      "poi_directions_map_url": "https://maps.google.com/?cid=5242468447430833348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "blue-zoo-aquarium-oklahoma-city",
      "poi_latitude": "35.6125884",
      "poi_longitude": "-97.5573925",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-477-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy4zKmxcdsocRxPRO80b9wEg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_9378ec33-a23e-46a9-b891-2e173b6aa632",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Sky Zone",
      "poi_type": "Entertainment",
      "poi_address": "2525 S Broadway, Edmond, OK 73013, USA",
      "poi_short_description": "Chain of indoor trampoline parks featuring freestyle bouncing, dodgeball, fitness programs & more.",
      "poi_long_description": "People say this amusement park offers a variety of trampolines and activities suitable for kids, teens, and young adults. They also highlight the reasonable membership prices with discounts on food and drinks, and the kind and helpful staff.\n\nSome reviews mention the facilities can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-5b54-7010-a0d4-2aa88dee6490.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-5b54-7010-a0d4-2aa88dee6490",
        "storage_key": "property/6767906449167311/019d07dd-5b54-7010-a0d4-2aa88dee6490.webp",
        "width": 1200,
        "height": 1200
      },
      "poi_business_url": "https://www.skyzone.com/edmond/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11100529412539313541&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone",
      "poi_latitude": "35.6300623",
      "poi_longitude": "-97.4862479",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-359-1631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ75ZG2_wesocRhW0uBbAADZo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_5d96fc11-3589-4e4a-8283-09925f93a84d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Chad Richison Stadium",
      "poi_type": "Entertainment",
      "poi_address": "100 E University Dr, Edmond, OK 73034, USA",
      "poi_short_description": "Arena for the University of Central Oklahoma Bronchos football team.",
      "poi_long_description": "People say this stadium offers a fun experience with soccer games and drone shows. They highlight the clean facilities and easy parking. They also like the friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-5af5-7374-bb5a-0ee4680d9145.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-5af5-7374-bb5a-0ee4680d9145",
        "storage_key": "property/6767906449167311/019d07dd-5af5-7374-bb5a-0ee4680d9145.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://bronchosports.com/sports/2011/6/10/FB_0610111744.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10132052462898693569&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chad-richison-stadium",
      "poi_latitude": "35.6615698",
      "poi_longitude": "-97.4707792",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-974-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-35a2-71ff-b7cf-dfc2da61d874.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-35a2-71ff-b7cf-dfc2da61d874",
        "storage_key": "property/6767906449167311/019d07dd-35a2-71ff-b7cf-dfc2da61d874.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhdKbbbcfsocRwcWyeAhInIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_a42f9bbb-2931-4ef4-9ec5-90fae922c9f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Edmond History Museum",
      "poi_type": "Entertainment",
      "poi_address": "431 S Blvd, Edmond, OK 73034, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this museum offers a variety of interesting displays and hands-on activities, especially for children. They highlight the free admission, rotating exhibits, and the option of a gift shop and donation box. They also like the friendly staff and the preservation of the building's historical significance.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-5f2c-774a-87d9-e3ceff5c88dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-5f2c-774a-87d9-e3ceff5c88dc",
        "storage_key": "property/6767906449167311/019d07dd-5f2c-774a-87d9-e3ceff5c88dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.edmondhistory.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=107138316684570186&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "edmond-history-museum",
      "poi_latitude": "35.650103",
      "poi_longitude": "-97.4784",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-340-0078",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-3596-73ec-bae3-5126a7a738ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-3596-73ec-bae3-5126a7a738ed",
        "storage_key": "property/6767906449167311/019d07dd-3596-73ec-bae3-5126a7a738ed.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJy3Bcga0fsocRSi7RO7uhfAE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_ad1fb2e4-0525-462b-81cc-0f1d1b990a04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Dobson Field",
      "poi_type": "Entertainment",
      "poi_address": "Baird Loop, Edmond, OK 73013, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-5f5f-7647-923a-cb7c799fde0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-5f5f-7647-923a-cb7c799fde0b",
        "storage_key": "property/6767906449167311/019d07dd-5f5f-7647-923a-cb7c799fde0b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9132438859912438972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "dobson-field",
      "poi_latitude": "35.6139766",
      "poi_longitude": "-97.4731539",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-35a2-71ff-b7cf-dfc2da61d874.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-35a2-71ff-b7cf-dfc2da61d874",
        "storage_key": "property/6767906449167311/019d07dd-35a2-71ff-b7cf-dfc2da61d874.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJn_Ha_3IfsocRvOQN4sHwvH4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_4b2cd369-d65b-46f6-9ca3-0e0023783208",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Mitch Park YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2901 Marilyn Williams Dr, Edmond, OK 73003, USA",
      "poi_short_description": "Clean sports facility featuring a fitness center and an outdoor track, as well as an indoor pool, disc golf and basketball courts.",
      "poi_long_description": "People say this gym offers a wide variety of workout equipment, including cardio and weight machines, as well as amenities like pools, a lazy river, a water slide, and courts for basketball and pickleball. They also highlight the clean facilities, friendly staff, and numerous classes available.\n\nOther reviews mention the equipment can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-601d-778d-9076-005d9c8a5f29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-601d-778d-9076-005d9c8a5f29",
        "storage_key": "property/6767906449167311/019d07dd-601d-778d-9076-005d9c8a5f29.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ymcaokc.org/branches/mitch-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15994863836961186949&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mitch-park-ymca",
      "poi_latitude": "35.6847017",
      "poi_longitude": "-97.5083114",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-330-4016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-eeHJvT1sYcRhSTQUOor-d0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7b36d97e-5a23-4f09-be07-4183732a38b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "2563 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a variety of services, including cardio/weights, group fitness, swimming, tennis, and pickleball. They also highlight the attentive lifeguards, the well-maintained facilities, and the excellent childcare program.\n\nSome reviews mention the equipment can be broken.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-5ff3-744d-9b29-5e1d952d098a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-5ff3-744d-9b29-5e1d952d098a",
        "storage_key": "property/6767906449167311/019d07dd-5ff3-744d-9b29-5e1d952d098a.webp",
        "width": 1088,
        "height": 1088
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/oklahoma-city.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=13614994550085944548&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "35.61423510000001",
      "poi_longitude": "-97.5602129",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-832-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWAnM3kdsocR5ITAcGgt8rw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1942b19a-ec44-463e-a5b7-3c394bb91dd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Crunch Fitness - Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "12508 N May Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Gym, part of a chain, offering yoga, cardio and weights rooms, and tanning beds.",
      "poi_long_description": "Some gym goers say this gym has a wide variety of equipment, including squat racks, free weights, cardio machines, and a sauna, and they praise the friendly and helpful staff and trainers, particularly Dinafor.\n\nOther reviews mention the gym can be crowded during peak hours and the locker rooms can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-656d-73ec-8cb2-d2627e76968e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-656d-73ec-8cb2-d2627e76968e",
        "storage_key": "property/6767906449167311/019d07dd-656d-73ec-8cb2-d2627e76968e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/quail-springs",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097941148085874568&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---oklahoma-city",
      "poi_latitude": "35.5969373",
      "poi_longitude": "-97.565988",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-497-8160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8Z8NgOkdsocRiG_leCo9oFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4259e6da-d419-4c46-be21-60314a8d3412",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Crunch Fitness - Edmond",
      "poi_type": "Health and Wellness",
      "poi_address": "2121 W Danforth Rd, Edmond, OK 73003, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, cable rigs, benches, leg presses, and powerlifting stations, and has a spacious layout with plenty of cardio machines.\n\nOther reviews mention the restrooms can be poorly maintained and classes can be difficult to book.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-6578-77ea-af16-85471ca799e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-6578-77ea-af16-85471ca799e2",
        "storage_key": "property/6767906449167311/019d07dd-6578-77ea-af16-85471ca799e2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/edmond",
      "poi_directions_map_url": "https://maps.google.com/?cid=8462207099918585172&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---edmond",
      "poi_latitude": "35.6692665",
      "poi_longitude": "-97.5106805",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-920-1940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo1bUEHcfsocRVI1vzoXMb3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_679ccab1-0bba-4695-9d63-afd272bc9922",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Oklahoma Gold Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "3001 Technology Dr, Edmond, OK 73013, USA",
      "poi_short_description": "Gym for kids offering classes in gymnastics and tumbling, plus birthday parties.",
      "poi_long_description": "People say this gymnastics center offers a variety of programs, including gymnastics and ninjastics, and hosts fun events like the M&M Olympics. They highlight the positive and encouraging atmosphere, and the personalized attention provided by the coaches. They also like the staff's dedication, professionalism, and genuine care for each child's progress and well-being.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-658e-76ca-8122-0b9419f95e29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-658e-76ca-8122-0b9419f95e29",
        "storage_key": "property/6767906449167311/019d07dd-658e-76ca-8122-0b9419f95e29.webp",
        "width": 1280,
        "height": 775
      },
      "poi_business_url": "http://www.oklahomagoldgymnastics.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=191096937127623553&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-gold-gymnastics",
      "poi_latitude": "35.6263031",
      "poi_longitude": "-97.4926773",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-341-1175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d4a8d42da38a",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw7GpO_AesocRgTso36bppgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8c1b5505-d08a-450e-88c0-60be56a185fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2209 W Edmond Rd, Edmond, OK 73003, USA",
      "poi_short_description": "Laid-back fitness center featuring workout machines plus massage chairs and tanning beds.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and amenities, including tanning beds and massage chairs. They highlight the clean and well-maintained facility, and the convenient hours. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-6626-70ab-bf1c-ac1faf50723d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-6626-70ab-bf1c-ac1faf50723d",
        "storage_key": "property/6767906449167311/019d07dd-6626-70ab-bf1c-ac1faf50723d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/edmond-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12798186502624872755&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "35.6543154",
      "poi_longitude": "-97.5129943",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 405-697-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu4H7420esocRM4knAtFKnLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_76f9d1c2-d522-4b9b-ba3c-10c7eb2b0d38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "TB Fit Club | TB Golf | TB Recovery",
      "poi_type": "Health and Wellness",
      "poi_address": "3333 W Hefner Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of new and modern equipment, including a golf simulator and expanded recovery options, and the staff are helpful and professional.\n\nOther reviews mention the facilities can be poorly maintained and the air conditioning can be inadequate.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-6a85-729d-baa7-232b581d0a0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-6a85-729d-baa7-232b581d0a0c",
        "storage_key": "property/6767906449167311/019d07dd-6a85-729d-baa7-232b581d0a0c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://tbfitclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12558554567901756546&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tb-fit-club--tb-golf--tb-recovery",
      "poi_latitude": "35.5816564",
      "poi_longitude": "-97.5782735",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-849-9173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSfqhdqYbsocRgrwkaNfySK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_69a6a241-f4d3-4269-9db8-6c61a27815b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Scissors & Scotch",
      "poi_type": "Health and Wellness",
      "poi_address": "13230 Pawnee Dr #202, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Upscale barber shop for beard trims and straight-razor shaves alongside a private lounge and a full bar with whisky. Waxing, manicures and massages are also offered.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://scissorsscotch.com/locations/ok/oklahoma-city/chisholm-creek/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17460232672315201299&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "scissors--scotch",
      "poi_latitude": "35.60419",
      "poi_longitude": "-97.5337642",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 405-486-4902",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62z3xRocsocRE1cEcRs1T_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_a50fd493-6e9e-4d27-a16c-62190d5efdd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Metro Gymnastics",
      "poi_type": "Health and Wellness",
      "poi_address": "7420 Broadway Ext, Oklahoma City, OK 73116, USA",
      "poi_short_description": "Gymnastics center offering classes and birthday parties for kids of various ages.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-6a6e-77d9-a9fb-7a69e510a535.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-6a6e-77d9-a9fb-7a69e510a535",
        "storage_key": "property/6767906449167311/019d07dd-6a6e-77d9-a9fb-7a69e510a535.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metrogymokc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3312655711320854520&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "metro-gymnastics",
      "poi_latitude": "35.5464292",
      "poi_longitude": "-97.5132581",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-848-5308",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d4a8d42da38a",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSXSRwJwZsocR-M9yeNHq-C0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_864139d5-34c5-4c78-aca1-6164a2321cf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Mercy Hospital Oklahoma City",
      "poi_type": "Health and Wellness",
      "poi_address": "4300 W Memorial Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-27c8-7109-8667-4f7be0d95ef1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-27c8-7109-8667-4f7be0d95ef1",
        "storage_key": "property/6767906449167311/019d07dd-27c8-7109-8667-4f7be0d95ef1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.mercy.net/practice/mercy-hospital-oklahoma-city?utm_source=google&utm_medium=organic_search&utm_campaign=yext&utm_term=West&utm_content=website&y_source=1_MTI5OTY2MDItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9313836111055257082&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mercy-hospital-oklahoma-city",
      "poi_latitude": "35.607198",
      "poi_longitude": "-97.600529",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-755-1515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-394a-759d-8ab7-aa90fa1957e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-394a-759d-8ab7-aa90fa1957e6",
        "storage_key": "property/6767906449167311/019d07dd-394a-759d-8ab7-aa90fa1957e6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJE-YSHLkcsocR-n2nn5hkQYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_5720e53b-3555-4450-8a7b-5be74a76df46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Oklahoma Heart Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "4050 W Memorial Rd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-27f0-71f5-9674-c6d89aa09670.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-27f0-71f5-9674-c6d89aa09670",
        "storage_key": "property/6767906449167311/019d07dd-27f0-71f5-9674-c6d89aa09670.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.okheart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7955518146030748896&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-heart-hospital",
      "poi_latitude": "35.608268",
      "poi_longitude": "-97.5970489",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-608-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-394a-759d-8ab7-aa90fa1957e6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-394a-759d-8ab7-aa90fa1957e6",
        "storage_key": "property/6767906449167311/019d07dd-394a-759d-8ab7-aa90fa1957e6.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJW8z9OL8csocR4ERWipqtZ24",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_fd93b315-fc87-48fa-bc0e-7adca7d65a4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Martin Park Nature Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5000 W Memorial Rd, Oklahoma City, OK 73142, USA",
      "poi_short_description": "Park with trails through woods & grassland, plus amenities including a playground & nature center.",
      "poi_long_description": "People say this park offers beautiful walking trails, a playground, and opportunities to see wildlife like deer, turtles, and birds. They highlight the peaceful and serene atmosphere, and the well-maintained trails suitable for light hikes. They also like the friendly and knowledgeable staff at the visitor center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-1aeb-70c4-a47c-15a2234733f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-1aeb-70c4-a47c-15a2234733f2",
        "storage_key": "property/6767906449167311/019d07dd-1aeb-70c4-a47c-15a2234733f2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.okc.gov/departments/parks-recreation/martin-park-nature-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=9715724291787303274&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martin-park-nature-center",
      "poi_latitude": "35.6090059",
      "poi_longitude": "-97.6090052",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-297-1429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-3960-71cb-ad08-cd308f44d01a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-3960-71cb-ad08-cd308f44d01a",
        "storage_key": "property/6767906449167311/019d07dd-3960-71cb-ad08-cd308f44d01a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ71CwarQcsocRaqmda8Qv1YY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8efdb898-4ec1-4085-bbff-52a48c7a62cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Stars And Stripes Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3701 S Lake Hefner Dr, Oklahoma City, OK 73116, USA",
      "poi_short_description": "This park with a lake boasts a patriotic-themed playground plus baseball fields & a trail.",
      "poi_long_description": "People say this city park offers a large playground with multiple play areas for different age groups, walking trails, and panoramic views of the lake. They highlight the numerous tables, BBQ spaces, and decent parking, as well as the ability to build sandcastles and watch boats. They also like the workout area, skatepark, basketball courts, and bike path.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-6d17-74cb-a67b-0ae31c7e1206.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-6d17-74cb-a67b-0ae31c7e1206",
        "storage_key": "property/6767906449167311/019d07dd-6d17-74cb-a67b-0ae31c7e1206.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/34/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=16012526237037472583&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "stars-and-stripes-park",
      "poi_latitude": "35.5500436",
      "poi_longitude": "-97.5822759",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-297-2756",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-3960-71cb-ad08-cd308f44d01a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-3960-71cb-ad08-cd308f44d01a",
        "storage_key": "property/6767906449167311/019d07dd-3960-71cb-ad08-cd308f44d01a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2tmaBwbsocRR6s9S8brN94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_c0dc4037-41a7-42de-b5a6-06b95491f4c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Bluff Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11301 N Meridian Ave, Oklahoma City, OK 73120, USA",
      "poi_short_description": "Dirt & paved hiking & biking trails wind through a wooded glen, with 3 covered picnic pavilions.",
      "poi_long_description": "Visitors say this park offers well-maintained walking, jogging, and biking trails, with opportunities to see wildlife like deer. They also highlight the peaceful atmosphere, ideal for enjoying nature and escaping the everyday hustle and bustle.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-6d50-726e-84bc-eca25131096e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-6d50-726e-84bc-eca25131096e",
        "storage_key": "property/6767906449167311/019d07dd-6d50-726e-84bc-eca25131096e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.okc.gov/Home/Components/FacilityDirectory/FacilityDirectory/8/2846",
      "poi_directions_map_url": "https://maps.google.com/?cid=1559565554729670411&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bluff-creek-park",
      "poi_latitude": "35.584442",
      "poi_longitude": "-97.6065873",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-837-7995",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-3960-71cb-ad08-cd308f44d01a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-3960-71cb-ad08-cd308f44d01a",
        "storage_key": "property/6767906449167311/019d07dd-3960-71cb-ad08-cd308f44d01a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh3zaRlYbsocRC9eY7ZuwpBU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3a121dd5-a532-4ec7-858d-b5b2f7783430",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "E.C. Hafer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1034 S Bryant Ave, Edmond, OK 73034, USA",
      "poi_short_description": "Sizable park with a volleyball court, small fishing pond, trails & playgrounds, plus grassy areas.",
      "poi_long_description": "Visitors say this park offers a paved walking trail, playgrounds, picnic tables, pavilions, a sand volleyball court, workout stations, and a duck pond. They also highlight the scenic views, abundance of trees, and family-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-6f8d-768c-9899-0c1d238615a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-6f8d-768c-9899-0c1d238615a4",
        "storage_key": "property/6767906449167311/019d07dd-6f8d-768c-9899-0c1d238615a4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://edmondok.com/facilities/Facility/Details/9",
      "poi_directions_map_url": "https://maps.google.com/?cid=2633511566572246196&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ec-hafer-park",
      "poi_latitude": "35.6428821",
      "poi_longitude": "-97.4551926",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 405-359-4630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-3960-71cb-ad08-cd308f44d01a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-3960-71cb-ad08-cd308f44d01a",
        "storage_key": "property/6767906449167311/019d07dd-3960-71cb-ad08-cd308f44d01a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJOa4APJ4fsocRtNRrHdEcjCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_324871a9-d66d-4187-a6df-1e93b478b021",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Rose Creek Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17031 N May Ave, Edmond, OK 73012, USA",
      "poi_short_description": "Private golf course with an on-site eatery, pickleball courts, a clubhouse and a patio.",
      "poi_long_description": "People say this private golf course offers a great golf course, restaurants, and facilities. They also highlight the amazing staff, beautiful scenery, and good vibes.\n\nOther reviews mention the course conditions can be unchanged.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-6fbf-77e4-9415-fb9ad1b4ef8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-6fbf-77e4-9415-fb9ad1b4ef8a",
        "storage_key": "property/6767906449167311/019d07dd-6fbf-77e4-9415-fb9ad1b4ef8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rosecreekgc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14897560691660009268&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-creek-country-club",
      "poi_latitude": "35.6449907",
      "poi_longitude": "-97.5686808",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-330-8220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-7e76-72cd-a9ff-991ecdb90f52.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-7e76-72cd-a9ff-991ecdb90f52",
        "storage_key": "property/6767906449167311/019d07dd-7e76-72cd-a9ff-991ecdb90f52.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJh8IOAwgdsocRNK83toTEvs4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_99269647-f318-4aef-8fd9-d64442194522",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Costco Member Service Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14501 Bogert Pkwy, Oklahoma City, OK 73134, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-725e-76a9-8859-780936461c34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-725e-76a9-8859-780936461c34",
        "storage_key": "property/6767906449167311/019d07dd-725e-76a9-8859-780936461c34.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3497496067160567460&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "costco-member-service-center",
      "poi_latitude": "35.6183037",
      "poi_longitude": "-97.5748651",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX18i7nkdsocRpG5ufiSaiTA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_558da243-b577-41b4-a7c8-73b80a888567",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Chesapeake Energy Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6100 N Western Ave, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-7236-73b9-af7a-ccdcf64f15ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-7236-73b9-af7a-ccdcf64f15ee",
        "storage_key": "property/6767906449167311/019d07dd-7236-73b9-af7a-ccdcf64f15ee.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.expandenergy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3999976576566005612&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chesapeake-energy-corporation",
      "poi_latitude": "35.5346273",
      "poi_longitude": "-97.5289016",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 405-848-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8cjlSYasocRbI8Z7IDFgjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d743db32-ea0f-4b83-a5a6-1dcc4a53d8c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Love's Corporate Office Building South",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10401 N Pennsylvania Ave, The Village, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-751d-764f-ba35-58edf017a2dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-751d-764f-ba35-58edf017a2dd",
        "storage_key": "property/6767906449167311/019d07dd-751d-764f-ba35-58edf017a2dd.webp",
        "width": 1280,
        "height": 881
      },
      "poi_business_url": "http://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14437476488466279899&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate-office-building-south",
      "poi_latitude": "35.5768571",
      "poi_longitude": "-97.5501262",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI5qho4IbsocR2y0WjF84XMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_b75b417b-42fc-440d-862c-e92dfd8c23f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Love's South Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2101 Vineyard Blvd, Oklahoma City, OK 73120, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-74d1-763e-9d08-1092d17df82d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-74d1-763e-9d08-1092d17df82d",
        "storage_key": "property/6767906449167311/019d07dd-74d1-763e-9d08-1092d17df82d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4360911662846330364&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-south-building",
      "poi_latitude": "35.5769306",
      "poi_longitude": "-97.5501889",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTfjgpJsbsocR_EXQYA0ShTw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_7815049d-4a99-4e99-8a9d-fbac707b1e33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Love's Corporate - Building 50",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3601 NW 63rd St, Oklahoma City, OK 73116, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-7752-77e9-9bc1-c1abeb23ca7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dd-7752-77e9-9bc1-c1abeb23ca7f",
        "storage_key": "property/6767906449167311/019d07dd-7752-77e9-9bc1-c1abeb23ca7f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.loves.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4599439798442847940&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "loves-corporate---building-50",
      "poi_latitude": "35.5374849",
      "poi_longitude": "-97.5809021",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-655-6837",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw8bq4uQasocRxO76tyB-1D8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f9681a07-0a5c-4cdd-b6c3-c74ed02231f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Scissortail Elementary School",
      "poi_type": "Education",
      "poi_address": "2301 NW 145th St, Oklahoma City, OK 73134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://scissortail.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14364707746399036880&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "scissortail-elementary-school",
      "poi_latitude": "35.6187575",
      "poi_longitude": "-97.5543923",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 405-340-2252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d4a8d42da38a",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFwC5_rEdsocR0KVqfpaxWcc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_a5cf4e64-7f6d-4eb5-91fc-0ee886eaee6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Summit Middle School",
      "poi_type": "Education",
      "poi_address": "1703 NW 150th St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-f5ba-70ea-a8b7-0a4965193c8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dc-f5ba-70ea-a8b7-0a4965193c8a",
        "storage_key": "property/6767906449167311/019d07dc-f5ba-70ea-a8b7-0a4965193c8a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://summit.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4052681169359623432&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "summit-middle-school",
      "poi_latitude": "35.625296",
      "poi_longitude": "-97.5414836",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-340-2920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d4a8d42da38a",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJueUCwjkcsocRCFWYLw0EPjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4cc6a731-7802-46b8-a0ad-08088959c195",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Edmond Santa Fe High School",
      "poi_type": "Education",
      "poi_address": "1901 W 15th St, Edmond, OK 73013, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-5858-77ba-a052-baf859a4828b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-5858-77ba-a052-baf859a4828b",
        "storage_key": "property/6767906449167311/019d7918-5858-77ba-a052-baf859a4828b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://santafe.edmondschools.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3158354544559100067&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "edmond-santa-fe-high-school",
      "poi_latitude": "35.6401779",
      "poi_longitude": "-97.5088169",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 405-340-2230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d4a8d42da38a",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPS_GbGIesocRo5Avf7m61Cs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_beb180b5-e7d4-444e-8955-b50b117803ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Oklahoma State University Oklahoma City",
      "poi_type": "Education",
      "poi_address": "900 N Portland Ave, Oklahoma City, OK 73107, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-5b62-77fe-b77c-018953900cb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-5b62-77fe-b77c-018953900cb6",
        "storage_key": "property/6767906449167311/019d7918-5b62-77fe-b77c-018953900cb6.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.osuokc.edu/home/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5945726857955521834&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-state-university-oklahoma-city",
      "poi_latitude": "35.4705492",
      "poi_longitude": "-97.5821887",
      "poi_miles_from_property": "12.4 mi",
      "poi_walking_minutes": "4 hours 38 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 405-947-4421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d4a8d42da38a",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d4a8d42da38a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGzr99UMQsocRKjXwUxN3g1I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ad3add31-e51d-43a7-a7a8-5d1292182a05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Chalk Realty",
      "poi_type": "Restaurants",
      "poi_address": "3 NE 8th St Suite 150, Oklahoma City, OK 73104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.chalkrealty.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16765001542470299007&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chalk-realty",
      "poi_latitude": "35.4763325",
      "poi_longitude": "-97.5117798",
      "poi_miles_from_property": "12.3 mi",
      "poi_walking_minutes": "4 hours 36 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-449-0863",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzVTIKEIXsocRf23R_RNAqeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "real_estate_agency"
    },
    {
      "id": "custom_97b51273-16c5-4c02-9a89-41cc5ec17ad2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Spark",
      "poi_type": "Restaurants",
      "poi_address": "1332 W Memorial Rd STE 101, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Fun, family-friendly burger restaurant with a playground & a menu featuring salads and chicken nuggets.",
      "poi_long_description": "People say this restaurant offers delicious burgers, chicken nuggets, and ice cream, as well as healthy options like veggie burgers and salads. They highlight the fun, retro vibe, the clean environment, and the outdoor play area for children. They also like the friendly and helpful service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-5825-74fd-837b-ecf945725c63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-5825-74fd-837b-ecf945725c63",
        "storage_key": "property/6767906449167311/019d7918-5825-74fd-837b-ecf945725c63.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://eatatspark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13649303883114812938&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "spark",
      "poi_latitude": "35.6060579",
      "poi_longitude": "-97.537173",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 405-849-4967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d9051e79f5e9",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlSFroDwdsocRChZriJARbL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4d0a6a16-aa13-4028-9097-782ef6ffef24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Uncle Julio's Oklahoma City",
      "poi_type": "Restaurants",
      "poi_address": "1344 W Memorial Rd, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Tex-Mex chain serving mesquite-grilled fare & margarita-sangria swirls in a hacienda-style space.",
      "poi_long_description": "People say this restaurant serves delicious Mexican food, including bacon-wrapped shrimp, fajitas, and enchiladas. They also highlight the fun atmosphere, the delicious chocolate piñata, and the attentive service.\n\nSome reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-5d89-7650-9e77-c1c11d2c70c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-5d89-7650-9e77-c1c11d2c70c5",
        "storage_key": "property/6767906449167311/019d7918-5d89-7650-9e77-c1c11d2c70c5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://unclejulios.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6592367220314025478&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "uncle-julio-s-oklahoma-city",
      "poi_latitude": "35.6075896",
      "poi_longitude": "-97.5374138",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-486-0720",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d9051e79f5e9",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJp4TdSPodsocRBi6_Gw_LfFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_f33deafc-eba7-409f-b485-a6eca42811b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "P.F. Chang's",
      "poi_type": "Restaurants",
      "poi_address": "13700 N Pennsylvania Ave, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Family-friendly chain offering creative takes on Asian fare in a striking space.",
      "poi_long_description": "People say this Chinese restaurant serves delicious lettuce wraps, orange chicken, and sesame chicken. They also highlight the attentive, friendly, and knowledgeable staff, and the quick service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-6590-754b-bcdd-3dd3667b888c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-6590-754b-bcdd-3dd3667b888c",
        "storage_key": "property/6767906449167311/019d7918-6590-754b-bcdd-3dd3667b888c.webp",
        "width": 900,
        "height": 600
      },
      "poi_business_url": "https://locations.pfchangs.com/ok/oklahomacity/13700-n-pennsylvania-ave.html?utm_source=google_gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=15109856492684494151&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "p-f-chang-s",
      "poi_latitude": "35.61040260000001",
      "poi_longitude": "-97.5486884",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-748-4003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d9051e79f5e9",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE69EAWscsocRR8WWtWz-sNE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_022c8674-5950-4a9f-9821-de5793eb502a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Fogo de Chão Brazilian Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "13810 N Pennsylvania Ave, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Upscale Brazilian chain for all-you-can-eat meat carved tableside plus an extensive salad bar.",
      "poi_long_description": "People say this Brazilian steakhouse offers a wide variety of delicious, perfectly grilled meats, including picanha, filet mignon, and lamb chops, as well as a fresh and diverse salad bar. They highlight the excellent value, especially for the \"Churrasco Experience,\" and the elegant, festive atmosphere. They also like the attentive, knowledgeable, and friendly staff, and the fast service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-7109-761c-9bea-d6758c6cac43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-7109-761c-9bea-d6758c6cac43",
        "storage_key": "property/6767906449167311/019d7918-7109-761c-9bea-d6758c6cac43.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://fogodechao.com/location/oklahoma-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3386455471637917847&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fogo-de-ch-o-brazilian-steakhouse",
      "poi_latitude": "35.6110589",
      "poi_longitude": "-97.5487051",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-753-0003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-d9051e79f5e9",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-d9051e79f5e9.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEU3u-2ocsocRl_CnKk8b_y4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brazilian_restaurant"
    },
    {
      "id": "custom_d3d71ba0-6a25-468c-b9e5-3469899bb8d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "2201 W Danforth Rd, Edmond, OK 73003, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "People say this department store offers a wide variety of products and good quality clothing. They also highlight the convenient Amazon return service and the helpful staff.\n\nOther reviews mention the checkout lines can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-6d4d-713e-8ff9-c339a308c186.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-6d4d-713e-8ff9-c339a308c186",
        "storage_key": "property/6767906449167311/019d7918-6d4d-713e-8ff9-c339a308c186.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/edmond-487.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=7193791877707590571&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "35.6691884",
      "poi_longitude": "-97.5120336",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 405-844-3713",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-dfc4a385d678.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-dfc4a385d678",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-dfc4a385d678.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtX12aRAesocRq-vZMpl71WM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_f41ad53a-f610-48a9-a29f-b37e609ac24a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Sam's Club Gas Station",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this gas station offers clean, quality gas. They highlight the prices are consistently low and the service is efficient. They also like the convenient app for payment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-6c62-7713-aff0-45fb8f239199.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-6c62-7713-aff0-45fb8f239199",
        "storage_key": "property/6767906449167311/019d7918-6c62-7713-aff0-45fb8f239199.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.samsclub.com/club/8117-oklahoma-city-ok/fuel-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=8632309291013477456&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club-gas-station",
      "poi_latitude": "35.607813",
      "poi_longitude": "-97.5480258",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-753-9751",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-974a-755d-a7ae-2f95c33d5127.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7918-974a-755d-a7ae-2f95c33d5127",
        "storage_key": "property/6767906449167311/019d7918-974a-755d-a7ae-2f95c33d5127.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ40NenmwcsocRUJQpcpAfzHc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_f13ef60e-ade7-4cbb-962a-868cc22039a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2000 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Department store carrying a wide range of merchandise, including electronics, home appliances, and groceries.",
      "poi_long_description": "People say this department store offers a wide variety of products, including groceries, home goods, and electronics, and provides convenient services like delivery and online pickup.\n\nOther reviews mention the service can be slow and the store can be understaffed.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-ecf3-73fc-a2ba-7ecd6ab40b37.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d07dc-ecf3-73fc-a2ba-7ecd6ab40b37",
        "storage_key": "property/6767906449167311/019d07dc-ecf3-73fc-a2ba-7ecd6ab40b37.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1626-oklahoma-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10140810101618845328&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.6052952",
      "poi_longitude": "-97.5460685",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 405-752-1900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-dfc4a385d678.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-dfc4a385d678",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-dfc4a385d678.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-WNQUWscsocRkCavIQ9lu4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_9f53f4f2-4c89-4142-9500-59c3d6a7a070",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Target Mobile",
      "poi_type": "Shopping & Retail",
      "poi_address": "13924 N Pennsylvania Ave, Oklahoma City, OK 73134, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-739e-77cc-964a-027e7ed3207a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-739e-77cc-964a-027e7ed3207a",
        "storage_key": "property/6767906449167311/019d7918-739e-77cc-964a-027e7ed3207a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.target.com/mobile",
      "poi_directions_map_url": "https://maps.google.com/?cid=7523990430698125957&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target-mobile",
      "poi_latitude": "35.6125122",
      "poi_longitude": "-97.5468412",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 405-752-0183",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-dfc4a385d678.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-dfc4a385d678",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-dfc4a385d678.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJe5CavWocsocRhToz026Vamg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cell_phone_store"
    },
    {
      "id": "custom_9d3fb360-85e2-4d12-9430-c13eef6c76fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Old Navy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2210 W Memorial Rd, Oklahoma City, OK 73134, USA",
      "poi_short_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_long_description": "Chain with a wide range of clothing for the family from jeans to loungewear, plus fun accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-749f-73c4-b017-b5946086a86b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-749f-73c4-b017-b5946086a86b",
        "storage_key": "property/6767906449167311/019d7918-749f-73c4-b017-b5946086a86b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://oldnavy.gap.com/stores/ok/oklahomacity/oldnavy-5878.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6995448886451740555&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "old-navy",
      "poi_latitude": "35.6068159",
      "poi_longitude": "-97.5518902",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 405-607-7663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-dfc4a385d678.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-dfc4a385d678",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-dfc4a385d678.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6Ynq4mscsocRi59b4bLTFGE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_7cd16cee-2b75-467e-85e9-0dc0d1a337e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Fenwick Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "16875 N Pennsylvania Ave, Edmond, OK 73012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-74ce-736e-9906-f72a2e68e37b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-74ce-736e-9906-f72a2e68e37b",
        "storage_key": "property/6767906449167311/019d7918-74ce-736e-9906-f72a2e68e37b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10753402472297912908&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fenwick-shopping-center",
      "poi_latitude": "35.6405173",
      "poi_longitude": "-97.5489551",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-31e3-742d-a03b-dfc4a385d678.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-31e3-742d-a03b-dfc4a385d678",
        "storage_key": "property/6767906449167311/019d07dd-31e3-742d-a03b-dfc4a385d678.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJadswM7QdsocRTNofGJPCO5U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_79aed24c-575f-4266-9ea1-633acdccca73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Flix Brewhouse Oklahoma City",
      "poi_type": "Entertainment",
      "poi_address": "8590 Broadway Ext, Oklahoma City, OK 73114, USA",
      "poi_short_description": "Casual cinema chain offering new releases on multiple screens with reclining seats and chair-side service for food and drinks.",
      "poi_long_description": "People say this movie theater offers a wide selection of beers, mixed drinks, and a dinner menu with options like pizza, nachos, and fish and chips. They also highlight the comfortable reclining seats, the ability to order food and drinks from your seat, and the friendly and attentive service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-7a46-71bb-9303-e54265b54e52.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-7a46-71bb-9303-e54265b54e52",
        "storage_key": "property/6767906449167311/019d7918-7a46-71bb-9303-e54265b54e52.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://flixbrewhouse.com/theaters/g000t-flix-brewhouse-oklahoma-city/?utm_source=google&utm_medium=organic&utm_campaign=gbp_location&utm_content=%3Ccity%3E",
      "poi_directions_map_url": "https://maps.google.com/?cid=431007296085095709&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "flix-brewhouse-oklahoma-city",
      "poi_latitude": "35.5571098",
      "poi_longitude": "-97.5126037",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 405-766-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-3599-7764-895b-3f94aa0f250e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-3599-7764-895b-3f94aa0f250e",
        "storage_key": "property/6767906449167311/019d07dd-3599-7764-895b-3f94aa0f250e.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJbUPfS6YZsocRHfXAKto--wU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_7373e53a-d99b-4c57-8acc-83e39daae43c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Lake Hefner",
      "poi_type": "Entertainment",
      "poi_address": "Lake Hefner, Oklahoma City, OK 73120, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=5400634991969834440&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lake-hefner",
      "poi_latitude": "35.5769492",
      "poi_longitude": "-97.5768652",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXY-RLXIbsocRyBXoUeno8ko",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5e52b69b-836f-45ff-8408-57c605548021",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Science Museum Oklahoma",
      "poi_type": "Entertainment",
      "poi_address": "2020 Remington Pl, Oklahoma City, OK 73111, USA",
      "poi_short_description": "Expansive museum with child-friendly, hands-on exhibits, plus a planetarium & cafe.",
      "poi_long_description": "People say this science museum offers a wide variety of fun, interactive exhibits and activities, including a planetarium and a slanted room. They highlight the educational value, the engaging live shows, and the spacious layout that prevents overcrowding. They also like the friendly and knowledgeable staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-7d28-77cf-95cf-5c52d5207e84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-7d28-77cf-95cf-5c52d5207e84",
        "storage_key": "property/6767906449167311/019d7918-7d28-77cf-95cf-5c52d5207e84.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.sciencemuseumok.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11678503685854338412&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "science-museum-oklahoma",
      "poi_latitude": "35.5237553",
      "poi_longitude": "-97.4754913",
      "poi_miles_from_property": "10.5 mi",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 405-602-6664",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-3596-73ec-bae3-5126a7a738ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-3596-73ec-bae3-5126a7a738ed",
        "storage_key": "property/6767906449167311/019d07dd-3596-73ec-bae3-5126a7a738ed.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTLOFjEYsocRbB1wFzphEqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_d4b0f7ed-2ad2-442e-b8bc-8340d8685426",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Myriad Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "301 W Reno Ave, Oklahoma City, OK 73102, USA",
      "poi_short_description": "A 15-acre facility with formal gardens, a tropical conservatory, a dog park & horticultural classes.",
      "poi_long_description": "People say this botanical garden offers a wide variety of plants, including tropical plants, orchids, and tulips, and features a conservatory, greenhouse, and walking paths. They highlight the beautiful and peaceful atmosphere, perfect for relaxing and taking photos, and the family-friendly amenities, such as a playground, splash pad, and carousel. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-7bb1-7598-ab76-76e567902cfd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-7bb1-7598-ab76-76e567902cfd",
        "storage_key": "property/6767906449167311/019d7918-7bb1-7598-ab76-76e567902cfd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.myriadgardens.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10363530004578021372&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "myriad-botanical-gardens",
      "poi_latitude": "35.46533110000001",
      "poi_longitude": "-97.5179073",
      "poi_miles_from_property": "12.5 mi",
      "poi_walking_minutes": "4 hours 42 mins",
      "poi_biking_minutes": "1 hour 11 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 405-445-7080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-359a-735f-9ebb-d4462b79234b",
        "storage_key": "property/6767906449167311/019d07dd-359a-735f-9ebb-d4462b79234b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA05XnykXsocR_K_5faGn0o8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_9c8d2ee6-cdd0-452c-8aff-cb335bc66a35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Bricktown River Walk Park",
      "poi_type": "Entertainment",
      "poi_address": "400 E Reno Ave, Oklahoma City, OK 73104, USA",
      "poi_short_description": "Landscaped park around the Bricktown Canal featuring walking trails, outdoor art & restaurants.",
      "poi_long_description": "People say this park offers a peaceful river walk, boat rides, and opportunities to view statues and murals. They highlight the clean and well-maintained paths, and the relaxing and enjoyable atmosphere. They also like the informative and comical boat tour guides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d7918-820e-72b4-8473-5993c7a57e1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7918-820e-72b4-8473-5993c7a57e1d",
        "storage_key": "property/6767906449167311/019d7918-820e-72b4-8473-5993c7a57e1d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://welcometobricktown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14979120011152276064&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bricktown-river-walk-park",
      "poi_latitude": "35.4620033",
      "poi_longitude": "-97.5054353",
      "poi_miles_from_property": "13.5 mi",
      "poi_walking_minutes": "5 hours 3 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 405-235-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dd-3960-71cb-ad08-cd308f44d01a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d07dd-3960-71cb-ad08-cd308f44d01a",
        "storage_key": "property/6767906449167311/019d07dd-3960-71cb-ad08-cd308f44d01a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqfsyU98WsocRYDqtkEmG4M8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9f67c88e-c344-46f5-839f-6aeba78457ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Langston University – Oklahoma City",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "langston-university-oklahoma-city",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1cb5986e-67c2-4da5-8996-16693447547e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Chef Ramseys",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "chef-ramseys",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e1b3fa52-760f-4cbe-9fc1-3629c50b60b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Joseph A. Bank",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "joseph-a-bank",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d8c223cc-8895-4691-9249-6e3c295ddcde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "custom",
      "poi_name": "Andretti’s",
      "poi_type": "Entertainment",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "andretti-s",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_b72898fc1d398ead3dd27867",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_c7e915d4cab53a98230c286a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6aff38a6765745d6ef8e7156",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_094562346180ce7da488366f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e8f2fe7d453c81696521f410",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_a658b60d66d666e774a90335",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_4a7e947415b7295a25d33833",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "day": "SUN",
      "open_time": "13:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_f5c0a9c56dff91a586f98f0c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "rating": "5",
      "name": "false",
      "text": "First off, the staff is incredible — so welcoming and genuinely helpful. Our move-in was smooth, and it immediately felt like home. It’s the perfect place if you’re not quite ready to buy but still want a beautiful, comfortable space. I’d recommend it to anyone.",
      "date": "false",
      "title": "Absolutely love living here!"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_2fcc6ce42d84529c294a9ad6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Virtual Tour 1",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/cuImGHVo71O?source=180"
    },
    {
      "id": "ec_b45240c4f900771fe3c3063b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Virtual Tour 2",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://vapi.apartments.com/video/play/o40sxvR1fse?source=180"
    },
    {
      "id": "ec_c0646f7209548dc92a42cbcd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e0124-d2d9-74bc-a31f-6ea491709853.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e0124-d2d9-74bc-a31f-6ea491709853",
        "storage_key": "property/6767906449167311/019e0124-d2d9-74bc-a31f-6ea491709853.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Diamond - 2BR, 2BA - 1,027SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=EqvFgD57ps2"
    },
    {
      "id": "ec_57755822f4c9d19c61d04bd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e0124-d338-726b-a6b3-ef7faee8d9d6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e0124-d338-726b-a6b3-ef7faee8d9d6",
        "storage_key": "property/6767906449167311/019e0124-d338-726b-a6b3-ef7faee8d9d6.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apex - 2BR, 2BA - 935SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=tPLPBmWBLxx"
    },
    {
      "id": "ec_390037ab78dd3cc1c8f1de23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019e0124-d340-7743-affd-f07af4e04498.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e0124-d340-7743-affd-f07af4e04498",
        "storage_key": "property/6767906449167311/019e0124-d340-7743-affd-f07af4e04498.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Pearl - 1BR, 1BA - 766SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=dRo5vLQjDpK"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019d96ac-0192-74bf-adac-64036d2f5f66",
      "lead_source": "LANDING_PAGE",
      "name": "Zeal at Quail Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311"
    },
    {
      "lead_collector_id": "019d96ac-0312-707c-951f-0fb2eda3b031",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Zeal at Quail Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "apartments-with-pool-okc",
      "search_query": "apartments with pool in Oklahoma City",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Oklahoma City",
      "h2_subtitle": "Discover stylish apartments with pool amenities at Zeal at Quail in Oklahoma City. Dive into a refreshing lifestyle with exceptional community features.",
      "page_copy": "Looking for apartments with a pool in Oklahoma City? Zeal at Quail is your perfect destination. Nestled in the welcoming neighborhood of Northwest Oklahoma City, our community combines luxury with leisure. Our top-notch amenities include a shimmering pool where residents can unwind or engage in activities like our on-site corn hole games.\n\nOur thoughtfully designed one and two-bedroom apartments provide a perfect blend of comfort and modern style, enhanced by features like preinstalled WiFi by Cox and fenced yards for your furry friends. With central heat and air, you'll enjoy year-round comfort in any season. Let our dedicated management team help you settle into a vibrant lifestyle at Zeal at Quail, where modern living meets relaxation.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Oklahoma City",
      "seo_description": "Find your new home at Zeal at Quail! Enjoy apartments with a pool in Oklahoma City, featuring modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "luxury-apartments-dishwasher-okc",
      "search_query": "luxury apartments with dishwasher in OKC",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Dishwasher in OKC",
      "h2_subtitle": "Explore luxury apartments with dishwashers at Zeal at Quail in OKC. Experience modern comforts and premier living at our vibrant community.",
      "page_copy": "If you're searching for luxury apartments with a dishwasher in OKC, look no further than Zeal at Quail. Located in the heart of Northwest Oklahoma City, our upscale community offers a blend of modern luxury and everyday convenience. Each one and two-bedroom apartment comes with a state-of-the-art dishwasher, ensuring effortless living.\n\nBeyond the kitchen amenities, residents enjoy access to a sparkling pool and other perks like preinstalled Cox WiFi, pet-friendly yards, and a friendly atmosphere created by our dedicated management team. Whether you're relaxing in our stylish apartments or enjoying the vibrant community activities, Zeal at Quail is the perfect place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Dishwasher in OKC",
      "seo_description": "Live in comfort at Zeal at Quail. Discover luxury OKC apartments featuring modern dishwashers and exceptional amenities in a premier community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "okc-apts-air-conditioning",
      "search_query": "Oklahoma City apts with air conditioning",
      "category": "Amenity",
      "h1_title": "Oklahoma City Apts with Air Conditioning",
      "h2_subtitle": "Stay comfortable in Oklahoma City with apartments featuring air conditioning. Discover modern living at Zeal at Quail.",
      "page_copy": "For those seeking Oklahoma City apts with air conditioning, Zeal at Quail stands out as a prime choice for comfort and style. Located in the vibrant Northwest Oklahoma City area, our apartments offer a refuge from the Oklahoma heat with efficient central air conditioning systems.\n\nThe appeal of our community goes beyond climate comfort, featuring upscale amenities like a refreshing pool and private fenced yards perfect for pet lovers. Each one and two-bedroom apartment is designed with modern touches, including preinstalled WiFi provided by Cox, ensuring a seamless lifestyle. Join us at Zeal at Quail, where you can enjoy both luxury and practicality in your everyday living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Oklahoma City Apts with Air Conditioning",
      "seo_description": "Find comfortable living at Zeal at Quail with air-conditioned apartments in Oklahoma City, complete with modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "pet-friendly-apts-fenced-yards-okc",
      "search_query": "pet-friendly apartments with fenced yards OKC",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Fenced Yards OKC",
      "h2_subtitle": "Find pet-friendly apartments with fenced yards at Zeal at Quail in OKC. Enjoy a welcoming community tailored for you and your pets.",
      "page_copy": "Are you looking for pet-friendly apartments with fenced yards in OKC? Zeal at Quail in Northwest Oklahoma City is the perfect fit for you and your furry friends. Our community offers one and two-bedroom apartments designed with pet lovers in mind, featuring private fenced yards that provide a safe and enjoyable space for pets to play.\n\nBeyond the pet amenities, residents benefit from modern luxuries like a sparkling pool, preinstalled WiFi by Cox, and central heating and cooling systems. Managed by a dedicated team, Zeal at Quail ensures a comfortable lifestyle tailored to pet owners and their companions. Experience the best of pet-friendly living today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Fenced Yards OKC",
      "seo_description": "Zeal at Quail offers pet-friendly OKC apartments with fenced yards. Enjoy modern amenities and a welcoming environment for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "oklahoma-county-apartments-in-unit-laundry",
      "search_query": "Oklahoma County apartments with in-unit laundry",
      "category": "Amenity",
      "h1_title": "Oklahoma County Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover Oklahoma County apartments featuring in-unit laundry at Zeal at Quail. Enjoy convenience and modern living in our community.",
      "page_copy": "Experience the ultimate convenience with Oklahoma County apartments featuring in-unit laundry at Zeal at Quail. Our community, located in the desirable Northwest Oklahoma City, offers residents the comfort of modern living paired with the ease of personal laundry facilities.\n\nIn addition to the in-unit laundry, Zeal at Quail boasts exceptional amenities such as a sparkling swimming pool, pet-friendly yards, and central air conditioning. Each one and two-bedroom apartment is thoughtfully designed to meet the needs of today's residents, supported by a team dedicated to ensuring satisfaction. Choose Zeal at Quail and enjoy a seamless blend of luxury and functionality in your new home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Oklahoma County Apartments with In-Unit Laundry",
      "seo_description": "Zeal at Quail provides Oklahoma County apartments with in-unit laundry, offering convenience and modern amenities in a lively community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-nw-okc",
      "search_query": "one bedroom apartments northwest oklahoma city",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Northwest OKC",
      "h2_subtitle": "Explore one bedroom apartments in Northwest Oklahoma City at Zeal at Quail. Experience modern living with exceptional amenities today.",
      "page_copy": "Discover the perfect home at Zeal at Quail, offering one bedroom apartments in Northwest Oklahoma City that blend style with comfort. Nestled in a vibrant community, these apartments are thoughtfully designed with modern amenities to ensure a pleasant living experience.\n\nResidents enjoy features such as central air conditioning, preinstalled WiFi from Cox, and access to a sparkling pool. Our pet-friendly apartments with fenced yards offer additional comfort for you and your furry companions. Managed by a dedicated team, Zeal at Quail is committed to providing quality living in a welcoming environment. Make Zeal at Quail your next home and enjoy all that northwest OKC has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Northwest OKC",
      "seo_description": "Zeal at Quail offers stylish one bedroom apartments in Northwest OKC, featuring modern amenities and a pet-friendly environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-oklahoma-city-ok",
      "search_query": "two bedroom apartments oklahoma city ok",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Oklahoma City, OK",
      "h2_subtitle": "Find spacious two bedroom apartments in Oklahoma City, OK at Zeal at Quail. Enjoy modern living in a prime location.",
      "page_copy": "Zeal at Quail offers an exceptional selection of two bedroom apartments in Oklahoma City, OK. Our community is designed to provide spacious and stylish living accommodations in the heart of Northwest Oklahoma City. Each two-bedroom apartment combines modern design with comfort and functionality.\n\nResidents benefit from amenities like preinstalled WiFi provided by Cox, a refreshing swimming pool, and climate-controlled environments with central heat and air. Our pet-friendly community even boasts fenced yards, perfect for those with furry friends. With a committed management team on-site, Zeal at Quail promises a well-rounded living experience in Oklahoma City. Choose us as your next home and discover upscale apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Oklahoma City, OK",
      "seo_description": "Explore Zeal at Quail's two bedroom apartments in OKC, offering modern amenities, pet-friendly features, and a central location for comfortable living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "apartments-near-scissortail-elementary-okc",
      "search_query": "apartments near Scissortail Elementary School OKC",
      "category": "School",
      "h1_title": "Apartments Near Scissortail Elementary School",
      "h2_subtitle": "Discover convenient apartments near Scissortail Elementary in OKC at Zeal at Quail. Enjoy community living with great amenities.",
      "page_copy": "Zeal at Quail offers the perfect location for families seeking apartments near Scissortail Elementary School in Oklahoma City. Positioned in the thriving Northwest Oklahoma City area, our community combines convenience with modern living.\n\nFamilies will appreciate our spacious one and two-bedroom options, complete with preinstalled WiFi and pet-friendly policies. Residents can enjoy excellent features like a sparkling pool and fenced yards, providing both relaxation and security. The friendly on-site management team ensures all needs are met promptly, making Zeal at Quail an ideal choice for those prioritizing proximity to Scissortail Elementary School and a superior living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Scissortail Elementary School OKC",
      "seo_description": "Find family-friendly apartments near Scissortail Elementary School in OKC at Zeal at Quail, offering modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "rental-homes-near-summit-middle-school-ok-county",
      "search_query": "rental homes near Summit Middle School Oklahoma County",
      "category": "School",
      "h1_title": "Rental Homes Near Summit Middle School",
      "h2_subtitle": "Explore rental homes conveniently located near Summit Middle School in Oklahoma County at Zeal at Quail.",
      "page_copy": "Zeal at Quail presents an ideal opportunity for those seeking rental homes near Summit Middle School in Oklahoma County. Our community offers a selection of one and two-bedroom apartments, designed with comfort and modern amenities in mind.\n\nFamilies appreciate our location in Northwest Oklahoma City, close to Summits’ educational excellence. Leisure and convenience meet with features like a shimmering pool, energy-efficient central heating and air, and preinstalled WiFi powered by Cox. Our pet-friendly environment is enhanced by fenced yards, ensuring peace of mind for both residents and their pets. Zeal at Quail provides a seamless blend of quality living and strategic location, all managed by our committed team.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Homes Near Summit Middle School OK County",
      "seo_description": "Discover Zeal at Quail's rental homes near Summit Middle School in Oklahoma County, offering modern amenities and a family-friendly environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "apartments-close-to-edmond-santa-fe-high-nw-okc",
      "search_query": "apartments close to Edmond Santa Fe High School NW Oklahoma City",
      "category": "School",
      "h1_title": "Apartments Near Edmond Santa Fe High School",
      "h2_subtitle": "Discover premium apartments close to Edmond Santa Fe High School in NW Oklahoma City at Zeal at Quail.",
      "page_copy": "Zeal at Quail is your destination for quality living in apartments close to Edmond Santa Fe High School in Northwest Oklahoma City. Our community provides a range of one and two-bedroom apartments perfect for students and families seeking proximity to the school.\n\nSituated strategically, our residents enjoy effortless access to Edmond Santa Fe High School while benefiting from modern amenities such as a centrally heated and cooled environment, a refreshing swimming pool, and preinstalled WiFi from Cox. Pet enthusiasts will love our fenced yards, providing both safety and enjoyment for furry friends. Experience living in a community that blends comfort, convenience, and a welcoming atmosphere at Zeal at Quail.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Edmond Santa Fe High School",
      "seo_description": "Find Zeal at Quail's apartments near Edmond Santa Fe High School in NW OKC, featuring modern amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "apartment-listings-crossings-christian-lower-okc",
      "search_query": "apartment listings by Crossings Christian School Lower School OKC",
      "category": "School",
      "h1_title": "Apartment Listings Near Crossings Christian Lower",
      "h2_subtitle": "Explore apartment listings near Crossings Christian School Lower School in OKC at Zeal at Quail. Perfect for families seeking convenience.",
      "page_copy": "At Zeal at Quail, we provide premier apartment listings near Crossings Christian School Lower School in Oklahoma City. Our community is designed to support families with students attending this renowned institution, offering close proximity and ease of commute.\n\nLocated in vibrant Northwest Oklahoma City, Zeal at Quail features thoughtfully crafted one and two-bedroom units, each equipped with modern comforts like preinstalled WiFi and central air. Community amenities include a sparkling pool and pet-friendly fenced yards, ideal for relaxing after school activities. Our dedicated management team is always at hand, ensuring a supportive living environment with easy access to quality education at Crossings Christian School Lower.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Listings by Crossings Christian Lower OKC",
      "seo_description": "Check out Zeal at Quail's apartment listings near Crossings Christian School Lower School in OKC, offering family-friendly amenities and prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "apartments-near-quail-creek-elementary-okc",
      "search_query": "apartments by Quail Creek Elementary School in OKC",
      "category": "School",
      "h1_title": "Apartments Near Quail Creek Elementary",
      "h2_subtitle": "Find the perfect apartments by Quail Creek Elementary School in OKC at Zeal at Quail, offering family-friendly amenities and comfort.",
      "page_copy": "Zeal at Quail offers exceptional apartment living near Quail Creek Elementary School in Oklahoma City, ideal for families who value both quality education and convenience. Our one and two-bedroom homes are perfectly designed with modern families in mind.\n\nPositioned in the bustling area of Northwest Oklahoma City, our community provides easy access to Quail Creek Elementary School. Residents benefit from amenities such as a pool, preinstalled WiFi powered by Cox, central HVAC, and pet-friendly fenced yards. Managed by a team dedicated to resident satisfaction, Zeal at Quail is a fantastic place for families seeking apartments by this top-tier school.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Quail Creek Elementary in OKC",
      "seo_description": "Explore Zeal at Quail's apartments near Quail Creek Elementary School in OKC, featuring modern amenities and optimal location for families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "apartments-near-university-of-central-oklahoma",
      "search_query": "apartments near University of Central Oklahoma",
      "category": "School",
      "h1_title": "Apartments Near University of Central Oklahoma",
      "h2_subtitle": "Discover apartments near University of Central Oklahoma at Zeal at Quail, offering modern living and great community amenities.",
      "page_copy": "Zeal at Quail is the ideal choice for those seeking apartments near the University of Central Oklahoma. Situated in Northwest Oklahoma City, our community offers the perfect mix of modern design and convenience, making it an excellent choice for students or staff affiliated with the university.\n\nOur one and two-bedroom apartments are styled with comfort in mind, complete with central heat and air, high-speed WiFi, and access to a sparkling pool. The community at Zeal at Quail also includes a variety of recreational options such as corn hole games and pet-friendly fenced yards. Experience a supportive and dynamic living environment while enjoying proximity to the University of Central Oklahoma.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Central Oklahoma",
      "seo_description": "Find Zeal at Quail apartments near the University of Central Oklahoma, offering modern comforts and a vibrant community setup.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "oklahoma-christian-university-student-housing-options",
      "search_query": "Oklahoma Christian University student housing options",
      "category": "School",
      "h1_title": "Student Housing Near Oklahoma Christian University",
      "h2_subtitle": "Explore student housing options at Zeal at Quail near Oklahoma Christian University. Ideal for students looking for comfort and convenience.",
      "page_copy": "At Zeal at Quail, we offer ideal student housing options near Oklahoma Christian University. Located in the vibrant area of Northwest Oklahoma City, our community provides an excellent, comfortable living environment tailored for students' needs.\n\nOur spacious one and two-bedroom apartments come with preinstalled WiFi powered by Cox, central heat and air to ensure a comfortable study environment, and community features such as a sparkling pool and recreational areas. These amenities are perfect for students looking to balance academics with leisure. Choose Zeal at Quail for a supportive, enriching student life near Oklahoma Christian University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Student Housing Near Oklahoma Christian University",
      "seo_description": "Discover Zeal at Quail's student housing options near Oklahoma Christian University. Enjoy modern amenities, comfort, and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "apartments-near-integris-health-baptist-medical-center",
      "search_query": "apartments near integris health baptist medical center northwest oklahoma city",
      "category": "Hospital",
      "h1_title": "Apartments Near INTEGRIS Baptist Medical Center",
      "h2_subtitle": "Find the best apartments near INTEGRIS Health Baptist Medical Center in Northwest Oklahoma City at Zeal at Quail.",
      "page_copy": "Looking for comfortable living close to work? Zeal at Quail offers top-notch apartments near INTEGRIS Health Baptist Medical Center in Northwest Oklahoma City. Whether you're a medical professional or seeking care, our community offers convenience and comfort just a short drive away.\n\nOur thoughtfully designed one and two-bedroom apartments provide modern conveniences like preinstalled WiFi by Cox, central heating and cooling, and pet-friendly fenced yards. Residents enjoy amenities such as a fitness center, swimming pool, and recreational activities. Zeal at Quail balances quality living with proximity to key locations like INTEGRIS Health Baptist Medical Center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near INTEGRIS Health Baptist OKC",
      "seo_description": "Zeal at Quail offers modern apartments near INTEGRIS Health Baptist Medical Center in OKC, perfectly combining convenience with quality living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "apartments-near-martin-park-nature-center-oklahoma-city",
      "search_query": "apartments near Martin Park Nature Center Oklahoma City",
      "category": "Park",
      "h1_title": "Apartments Near Martin Park Nature Center OKC",
      "h2_subtitle": "Discover your perfect apartment near Martin Park Nature Center in Oklahoma City at Zeal at Quail, blending nature and modern living.",
      "page_copy": "Zeal at Quail is conveniently located for nature enthusiasts seeking apartments near Martin Park Nature Center in Oklahoma City. Nestled in the vibrant Northwest Oklahoma City area, our community offers easy access to the lush landscapes and walking trails of this local gem.\n\nOur spacious one and two-bedroom apartments provide all the comforts of modern living with amenities such as central air conditioning and preinstalled WiFi from Cox. Residents can enjoy a refreshing pool, pet-friendly yards, and outdoor games like corn hole. Experience the best of both worlds with a tranquil natural setting just moments from your doorstep at Zeal at Quail.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Martin Park Nature Center OKC",
      "seo_description": "Find ideal living at Zeal at Quail, with modern apartments near Martin Park Nature Center in Oklahoma City. Enjoy nature and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "apartments-close-to-will-rogers-gardens-okc",
      "search_query": "apartments close to Will Rogers Gardens Northwest Oklahoma City",
      "category": "Park",
      "h1_title": "Apartments Close to Will Rogers Gardens",
      "h2_subtitle": "Explore apartments close to Will Rogers Gardens in Northwest Oklahoma City. Enjoy serene living at Zeal at Quail.",
      "page_copy": "Situated in a prime location, Zeal at Quail offers modern apartments close to Will Rogers Gardens in Northwest Oklahoma City. Our community provides residents with easy access to this beautiful botanical haven, perfect for those who appreciate nature and outdoor activities.\n\nEach of our one and two-bedroom apartments features stylish amenities such as central heat and air, preinstalled WiFi by Cox, and spacious layouts. Enjoy community perks like our sparkling pool and pet-friendly spaces. Choose Zeal at Quail to experience a balanced lifestyle that combines the tranquility of Will Rogers Gardens with the convenience of city living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Will Rogers Gardens OKC",
      "seo_description": "Live near the scenic Will Rogers Gardens at Zeal at Quail. Discover modern apartments with easy access to botanical beauty in Northwest OKC.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "myriad-botanical-gardens-nearby-apartments-ok-73134",
      "search_query": "Myriad Botanical Gardens nearby apartments OK 73134",
      "category": "Park",
      "h1_title": "Nearby Apartments to Myriad Botanical Gardens",
      "h2_subtitle": "Find nearby apartments to Myriad Botanical Gardens in OK 73134 at Zeal at Quail, offering a blend of nature and urban comfort.",
      "page_copy": "Zeal at Quail offers exceptional living in the heart of Oklahoma City, conveniently situated for residents seeking nearby apartments to Myriad Botanical Gardens in the 73134 area. Our community provides an ideal location for those who love the vibrant atmosphere and stunning biodiversity that Myriad Botanical Gardens offers.\n\nOur thoughtfully crafted one and two-bedroom apartments come with modern luxuries, including central heating and air, and preinstalled WiFi by Cox. Enjoy community amenities such as a refreshing pool and pet-friendly fenced yards that enhance your living experience. Embrace the benefits of urban living while staying connected to natural beauty at Zeal at Quail.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Myriad Botanical Gardens OKC",
      "seo_description": "Zeal at Quail offers nearby apartments to Myriad Botanical Gardens in OKC 73134. Enjoy modern comforts and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449167311",
      "source": "generator",
      "page_item_url": "scissortail-park-apartments-oklahoma-county",
      "search_query": "Scissortail Park apartments Oklahoma County",
      "category": "Park",
      "h1_title": "Scissortail Park Apartments in OK County",
      "h2_subtitle": "Discover apartments near Scissortail Park in Oklahoma County at Zeal at Quail, where modern living meets natural beauty.",
      "page_copy": "Located within reach of the iconic Scissortail Park, Zeal at Quail offers a perfect setting for those seeking apartments in Oklahoma County. Nestled in the Northwest Oklahoma City neighborhood, our community beautifully balances access to nature with urban amenities.\n\nChoose from our spacious one and two-bedroom layouts, featuring exceptional amenities such as preinstalled WiFi by Cox and central heat and air. Our residents enjoy community perks like a sparkling pool and fenced pet areas, providing a perfect blend of luxury and convenience. Experience the benefits of living near the wonders of Scissortail Park at Zeal at Quail.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
      "featured_image_media": {
        "alt_text": "The Big Texan Steak Ranch building with Texas flags flying and a large bull statue.",
        "public_id": "019d07dc-b766-76ee-8e93-3122f4dabff1",
        "storage_key": "property/6767906449167311/019d07dc-b766-76ee-8e93-3122f4dabff1.webp",
        "width": 1365,
        "height": 768
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Scissortail Park Apartments in OK County",
      "seo_description": "Zeal at Quail offers premier apartments near Scissortail Park in Oklahoma County. Enjoy modern amenities and a great location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "6124"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-PZSPFH5N25"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11550732784"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/zeal-at-quail/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-5F3HLXXW"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449167311/019d74ae-991b-713e-b7de-830c2c4e4ff3.webp"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "53528527631"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "405-583-3549"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "69e17a26c6a2840ac85f5740"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImZrZDY4MFJmWVJCOWVWYU9qUHVuVHc9PSIsInZhbHVlIjoiZXpXWklqMmR6NHVCclE0eGd6VU5Kdz09IiwibWFjIjoiMDJjMWU1MmVhNzFmYTQxOTc5NTFmMTYzMzkzYzY5YWNlMjU0NjMxMGI4ZWJlYmJjN2QzNGY4ZDdmMTgwYzMxMSJ9"
    }
  ],
  "custom_qb_id": "6124",
  "custom_ga4_id": "G-PZSPFH5N25",
  "custom_repli_id": "11550732784",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/zeal-at-quail/register/",
  "custom_google_gtm_id": "GTM-5F3HLXXW",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449167311/019d74ae-991b-713e-b7de-830c2c4e4ff3.webp",
  "custom_hubspot_company_id": "53528527631",
  "custom_ppc_tracking_phone_number": "405-583-3549",
  "custom_residentboost_apartment_id": "69e17a26c6a2840ac85f5740",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImZrZDY4MFJmWVJCOWVWYU9qUHVuVHc9PSIsInZhbHVlIjoiZXpXWklqMmR6NHVCclE0eGd6VU5Kdz09IiwibWFjIjoiMDJjMWU1MmVhNzFmYTQxOTc5NTFmMTYzMzkzYzY5YWNlMjU0NjMxMGI4ZWJlYmJjN2QzNGY4ZDdmMTgwYzMxMSJ9"
};

export const generatedAt = '2026-08-27T21:32:34.787Z';
